import { pentaMock } from './mockPentagrama';
import { criarMockFounders } from './mockFounders';
import { criarMockIndicacoes } from './mockIndicacoes';
import { criarMockParceiros } from './mockParceiros';
import { criarMockCorreio } from './mockCorreio';
import { criarMockTopIdle } from './mockTopIdle';
import { avisarCorreio } from '../correio/aviso';
import type { CidadeItem, CidadeLoja, CasaOficio, FerramentaRegras, OficiosRegras, OficioOnde, FerramentaDaCidade,
  Account, Appearance, CharacterDetail, CharacterDraft, CharacterSummary, CosmeticPatch,
  CreationCatalog, Credentials, Friend, FriendLookup, GameApi, GmMob, GmOnline, GmOnlinePagina, GmSkills, GmSkinSet, TrajeExclusiva, Guild, GuildApplication, GuildListItem, GuildRankWire, Hotbar, HuntBoard, HuntEstimate, HuntOrder, HuntPostura, HuntView,   NpcShop, Pack, PackItem, Profile, Shard, SkillLock, OficinaFeito, OficinaMenu, Oficio, TailorMenu, FletchMenu, Craft,
  HouseModelo, HouseCatalogo, HouseBuy, MinhaCasa, CasaErguida, CasaPlaca, CasaItens, CasaItensMove, CasaPreso, CasaBau, Banco, BancoMove, MobResumo, LojaVitrine, LojaCompra, ColetaEstado, ColetaLugar, ColetaOrdem,
  SuporteChamado, SuporteNovo, RecompraResultado, VendaJanela, VendaItem, Inspecao, TrajeDoc, TrajeDto, DiscordEstado, SepararResultado
} from './types';
import { ApiError, CONFIRMAR_EMAIL, DOIS_FATORES_DESAFIO, DesafioDoisFatores, normalizeName } from './types';
import { DEFAULT_APPEARANCE, MOCK_CATALOG } from './catalogData';
import { MOCK_ITEM_CATALOG, MOCK_ITEM_DEFS, mockHands, mockStrReq, pecasDoKitGm, wornSlot } from './itemCatalog';
import { MATERIAIS, baseDe, idDaVariante } from '../look/materiais';
import { paraBarra } from '../data/hotbar';
import { HOTBAR_SIZE } from '../data/magias';
import { COMBATE_IDLE_VAZIO, COMBATE_IDLE_VERSAO, lerCombatIdle, type CombatIdleConfig } from '../data/combateIdle';
import { t } from '../i18n/idioma';
import { MOBILIA } from '../data/mobilia';
import { ALTURA_DO_MURO, FERRAMENTAS as FERRAMENTAS_OFICIO, alturaDe, cruzam, girosDe, oficioDe } from '../data/mobiliaInfo';
import { MS_POR_MINUTO, sincronizarHora } from '../world/relogio';
import { mockMinhas, mockRegras, mockTabela } from './mockRankings';
import { mockMercado } from './mockMercado';
import { MOCK_SETS_DE_SKIN, MOCK_SKINS, MOCK_TRAJE_CORES, MOCK_TRAJE_PECAS, MOCK_TRAJE_SLOTS, TINTA_PRIME, TRAJE_VAZIO } from './mockTraje';
import { clothDoTraje } from '../look/trajeVisual';
import { MOCK_VENDA_LOOT, MOCK_VENDA_PRECO, categoriaDaVenda, travaPadraoDaVenda } from './mockVendas';
import { MATIZ_DA_CAPA, NOME_DA_CAPA, criarMockChefe } from './mockChefe';
import { PREFIXO_SKIN, corDaTinta, itemDaTinta, skinDoItem } from '../components/guardaRoupa';

const SHARDS: readonly Shard[] = [
  { id: 'hellfire', name: 'Hellfire', region: 'Brasil · Sudeste', online: 2140, capacity: 5000, status: 'aberto', ping: 16 }
];

const SEED: readonly CharacterSummary[] = [
  // VITE_MOCK_CIDADE: abre o Aldric em outro mapa no modo mock (teste de tela do relevo, techspec-relevo).
  { id: 'c1', shardId: 'hellfire', name: 'Aldric',  profession: 'Ferreiro',   skillTotal: 412, homeCity: String(import.meta.env.VITE_MOCK_CIDADE || 'Minoc'), notoriety: 'inocente',  lastSeen: 'há 2 horas', skin: 'ghost', skinHue: 1009, dead: false },
  { id: 'c2', shardId: 'hellfire', name: 'Mirena',  profession: 'Escriba',    skillTotal: 268, homeCity: 'Minoc', notoriety: 'inocente', lastSeen: 'ontem', skin: 'ghost', skinHue: 1009, dead: false },
  { id: 'c3', shardId: 'hellfire', name: 'Corvus',  profession: 'Caçador',    skillTotal: 497, homeCity: 'Minoc', notoriety: 'criminoso', lastSeen: 'há 12 minutos', skin: 'ghost', skinHue: 1009, dead: false }
];

/**
 * Chamados de exemplo para o modo mock. `?mock-suporte=contato` acrescenta um pedido de detalhes
 * da equipe; `?mock-suporte=vazio` começa sem chamados; `?mock-suporte=limite` recusa o envio.
 */
function mockSuporte(): SuporteChamado[] {
  const modo = typeof window === 'undefined' ? '' : new URLSearchParams(window.location.search).get('mock-suporte') ?? '';
  if (modo === 'vazio') return [];
  const dia = (n: number) => new Date(Date.now() - n * 86_400_000).toISOString();
  const lista: SuporteChamado[] = [
    { numero: 1041, tipo: 'bug', assunto: 'textos', titulo: 'Texto cortado na janela de ofícios em espanhol',
      relato: 'Com o jogo em español, o nome de algumas receitas de alquimia passa da borda da janela.',
      frequencia: 'sempre', situacao: 'recebido', criadoEm: dia(0.1), analiseEm: null, pedidoEm: null, finalizadoEm: null, conversa: [] },
    { numero: 1034, tipo: 'sugestao', assunto: 'mercado', titulo: 'Filtro por metal no mercado',
      relato: 'Seria ótimo filtrar armas e armaduras por metal (ferro, cobre, valorite…) na busca do mercado.',
      frequencia: null, situacao: 'analise', criadoEm: dia(2), analiseEm: dia(1), pedidoEm: null, finalizadoEm: null, conversa: [] },
    { numero: 1027, tipo: 'bug', assunto: 'combate', titulo: 'Poção de vida some da barra depois de morrer',
      relato: 'Depois de morrer no Cemitério e voltar pelo Ankh, a poção que estava no F1 some da barra, mas continua na mochila.',
      frequencia: 'sempre', situacao: 'analisado', criadoEm: dia(6), analiseEm: dia(5), pedidoEm: null, finalizadoEm: dia(3), conversa: [] }
  ];
  if (modo === 'contato') {
    lista.unshift({
      numero: 1039, tipo: 'bug', assunto: 'banco', titulo: 'Personagem trava ao abrir o banco de Britain',
      relato: 'Quando clico no banqueiro de Britain a janela não abre e o personagem fica parado até eu recarregar.',
      frequencia: 'as-vezes', situacao: 'contato', criadoEm: dia(1), analiseEm: dia(0.5), pedidoEm: dia(0.2), finalizadoEm: null,
      conversa: [{ de: 'equipe', texto: 'Isso acontece só com o Aldric ou também com outro personagem da conta? Se lembrar, diga o horário aproximado da última vez.', em: dia(0.2) }]
    });
  }
  return lista;
}

const wait = (ms: number) => new Promise<void>(done => { setTimeout(done, ms); });

function looksLikeEmail(value: string): boolean {
  const at = value.indexOf('@');
  return at > 0 && at < value.length - 1;
}

function fromEmail(email: string): Account {
  const local = email.split('@')[0] || 'aventureiro';
  // ?mock-jogador=1: conta de jogador, sem o [GM] no nick (as fotos do guia: docs/prototipos/boas-vindas-nota.md).
  const jogador = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('mock-jogador') === '1';
  return { id: 'acc-mock', displayName: local, role: jogador ? 'player' : 'gm' };
}

function seedDetail(row: CharacterSummary): CharacterDetail {
  return {
    ...row,
    sex: 'male',
    stats: { str: 45, dex: 25, int: 10 },
    skills: MOCK_CATALOG.professions[0].skills ?? [],
    appearance: { ...DEFAULT_APPEARANCE }
  };
}

export function createMockApi(): GameApi {
  let session: Account | null = null;
  /** E-mails cadastrados que ainda esperam o código (techspec-confirmacao-email). */
  const pendentes = new Set<string>();
  // Os desafios do 2FA do mock (contas "gm…"): desafio → e-mail.
  const desafios = new Map<string, string>();
  let mockDiscord: DiscordEstado = {
    ligado: true, vinculado: false, cargos: [], pendente: false, erro: null, sincronizadoEm: null,
    convite: 'https://discord.gg/7mwCCQdy3M'
  };
  let mockPix: { id: string; consultas: number; ouro: number; centavos: number; estado: string; metodo?: 'pix' | 'cartao' } | null = null;
  // Um QR de mentira (1×1 branco): a demonstração não gera Pix de verdade.
  const pixDoMock = () => ({
    id: mockPix!.id, estado: mockPix!.estado, metodo: mockPix!.metodo ?? 'pix', pacoteId: 'demo', ouro: mockPix!.ouro, centavos: mockPix!.centavos,
    pixCopiaCola: mockPix!.estado === 'aguardando' && mockPix!.metodo !== 'cartao' ? '00020126DEMONSTRACAO-NADA-E-COBRADO' : null,
    pixQrBase64: mockPix!.estado === 'aguardando' && mockPix!.metodo !== 'cartao' ? 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg==' : null,
    // No mock, a "página do Mercado Pago" é a de retorno do próprio site.
    checkout: mockPix!.estado === 'aguardando' && mockPix!.metodo === 'cartao' ? '/pagamento-retorno.html?r=simulado' : null,
    criadoEm: new Date().toISOString(), expiraEm: new Date(Date.now() + 30 * 60_000).toISOString(),
    pagoEm: mockPix!.estado === 'pago' ? new Date().toISOString() : null, personagem: null, ambiente: 'teste' as const
  });
  const chars = SEED.map(c => ({ ...c }));
  const details = new Map<string, CharacterDetail>(SEED.map(c => [c.id, seedDetail(c)]));
  const idem = new Map<string, string>();
  let nextId = 100;
  const suporte: SuporteChamado[] = mockSuporte();
  let suporteSeq = 1042;
  const suporteHora: number[] = [];

  const listed = (shardId: string) => chars.filter(c => c.shardId === shardId);
  let activeShard = 'hellfire';
  const friends: Friend[] = [];
  const bag: MutablePack[] = [];
  let nextItem = 1;
  const weightMax = 180;
  const strength = 45;
  const skillLocks = new Map<string, SkillLock>();
  /** O marco do progresso das skills (techspec-progresso-skills); sem limpar, o mock mostra um pouco de ganho. */
  let marcoMock: Map<string, number> | null = null;
  let mockGmSkillValues: Map<string, number> | null = null;
  /** Força, Destreza e Inteligência do GM no mock (techspec-gm-atributos). */
  let mockGmAtributos = { for: 60, des: 45, int: 35 };
  const bars = new Map<string, (string | null)[]>();
  const combates = new Map<string, CombatIdleConfig>();
  /** Caçada espalhada por personagem (techspec-cacada-espalhada). */
  const espalhadas = new Set<string>();
  let house: Guild | null = null;
  let mockOculto = false;
  const mockMobs: GmMob[] = [];
  let mockMobSeq = 60000;
  const MOCK_MOB_DEFS: readonly MobResumo[] = [
    { defId: 'skeleton', nome: 'Esqueleto', hits: 46, ar: 20, magicResist: 25, poisonImmune: true, permiteParalisia: true },
    { defId: 'spirit-ghost', nome: 'Espírito', hits: 58, ar: 12, magicResist: 45, poisonImmune: true, permiteParalisia: true },
    { defId: 'zombie', nome: 'Zumbi', hits: 42, ar: 16, magicResist: 20, poisonImmune: true, permiteParalisia: true },
    { defId: 'lich', nome: 'Lich', hits: 120, ar: 28, magicResist: 85, poisonImmune: true, permiteParalisia: false },
    { defId: 'daemon-red', nome: 'Daemon Vermelho', hits: 300, ar: 52, magicResist: 80, poisonImmune: false, permiteParalisia: false }
  ];
  let directory: GuildListItem[] = [];
  const applied = new Set<string>();
  const apps: GuildApplication[] = [];
  let mockOrdem: HuntBoard['ordem'] = null;
  /**
   * Caçada contínua no mock (techspec-cacada-venda): `?mockvip=1` liga o VIP; `?mockpausa=cofre|venda` mostra a
   * pausa da mochila cheia em laço; `?mockfora=1` traz o cartão "Enquanto você esteve fora" até o OK.
   */
  const mockParam = (k: string) => {
    try { return new URLSearchParams(window.location.search).get(k); } catch { return null; }
  };
  const mockVip = mockParam('mockvip') === '1';
  let mockForaAberto = mockParam('mockfora') === '1';
  /** Coleta no mock: o relógio decide quantas tentativas já saíram (techspec-coleta §07). */
  let mockColeta: { inicio: number; terminaEm: number; origem: string; recurso: 'madeira' | 'minerio' } | null = null;
  let coletaDemo = false;
  /** Guarda-roupa no mock: `?mocktraje=1` põe duas tintas prime na mochila; `?mockfem=1` faz o personagem mulher. */
  let trajeMock: TrajeDoc = TRAJE_VAZIO;
  let trajeSalvo = false;
  const tintasGuardadas = new Set<string>();
  const trajeFem = mockParam('mockfem') === '1';
  /** Chefe do Mundo no mock: `?mockchefe=1` põe o Balron ao vivo; `?mockfrag=300` muda o saldo de fragmentos. */
  const chefeMock = criarMockChefe(mockParam);
  /** O correio (techspec-correio §06): os anexos entram na mochila, no cofre e no guarda-roupa do mock. */
  const correioMock = criarMockCorreio({
    item: (def, qtd, dur) => receberNoPack(def, qtd, dur, MOCK_ITEM_DEFS.get(def)?.name ?? def),
    cofre: (moeda, qtd) => { if (moeda === 'gold') bankGold += qtd; else bankSilver += qtd; },
    traje: peca => { skinsMock.add(peca); skinsVistas.delete(peca); }
  });
  if (typeof window !== 'undefined') (window as unknown as { __correioMock?: typeof correioMock }).__correioMock = correioMock;
  const topidleMock = criarMockTopIdle(() => { correioMock.chegarVotoMock(); avisarCorreio(true); });
  /** As skins do personagem no mock (techspec-skins): `?mockskin=1` já começa com o set do sexo dele. */
  const skinsMock = new Set<string>();
  /** As que o jogador já clicou para ver (sem o selo "Nova"). */
  const skinsVistas = new Set<string>();
  const exclusivasMock = (): TrajeExclusiva[] => [
    ...[...chefeMock.capas].map(id => ({ id, nome: NOME_DA_CAPA[id] ?? id, slot: 'capa', hue: MATIZ_DA_CAPA[id] ?? 0, bonus: 5, origem: 'altar', nova: !skinsVistas.has(id) })),
    ...MOCK_SKINS.filter(s => skinsMock.has(s.id)).map(s => ({ id: s.id, nome: s.nome, slot: s.slot, hue: 0, bonus: 0, origem: s.presa ? 'correio' : 'gm', set: s.set, soMulher: s.soMulher, tingivel: !!s.tingivel, presa: !!s.presa, nova: !skinsVistas.has(s.id) }))
  ];
  const skinSetMock = (s: (typeof MOCK_SETS_DE_SKIN)[number]): GmSkinSet => ({
    id: s.id, nome: s.nome, icone: s.icone,
    pecas: s.pecas.map(id => {
      const p = MOCK_SKINS.find(x => x.id === id)!;
      return { id: p.id, nome: p.nome, slot: p.slot, soMulher: p.soMulher, tem: skinsMock.has(p.id) };
    })
  });
  if (mockParam('mockskin') === '1') for (const p of MOCK_SETS_DE_SKIN[trajeFem ? 1 : 0].pecas) skinsMock.add(p);
  /** `?mockcajado=1`: o cajado retorcido na mão, para ver a skin de cajado no lugar dele (techspec-skins). */
  const mockCajado = mockParam('mockcajado') === '1';
  /** `?mockgm=1`: ~3000 jogadores falsos para o menu do GM (busca, sala, ficha) — techspec-gm-menu §09. */
  const falsosGm: GmOnline[] = mockParam('mockgm') === '1' ? gerarFalsosGm(3000) : [];
  const gmFalso = (id: string, muda: Partial<GmOnline> = {}): GmOnline | null => {
    const i = falsosGm.findIndex(f => f.id === id);
    if (i < 0) return null;
    falsosGm[i] = { ...falsosGm[i], ...muda };
    return falsosGm[i];
  };
  const trajeDto = (): TrajeDto => ({
    slots: MOCK_TRAJE_SLOTS, pecas: MOCK_TRAJE_PECAS, cores: MOCK_TRAJE_CORES, feminino: trajeFem,
    traje: trajeMock, salvo: trajeSalvo, guardadas: MOCK_TRAJE_CORES.filter(c => tintasGuardadas.has(c.id)).map(c => c.id),
    exclusivas: exclusivasMock()
  });

  if (mockCajado) {
    const def = MOCK_ITEM_DEFS.get('gnarled-staff');
    bag.push({ id: `i${nextItem++}`, defId: 'gnarled-staff', name: def?.name ?? 'Gnarled staff', qty: 1, dur: 50, durMax: 50, weight: def?.weight ?? 3, equippedSlot: 'mainHand' });
  }
  if (mockParam('mocktraje') === '1') {
    for (const [cor, qty] of [['fogo', 2], ['sombra', 1]] as const) {
      const def = MOCK_ITEM_DEFS.get(TINTA_PRIME + cor);
      bag.push({ id: `i${nextItem++}`, defId: TINTA_PRIME + cor, name: def?.name ?? cor, qty, dur: null, durMax: null, weight: 0.1 * qty, equippedSlot: null });
    }
  }
  const mockLenhador = 42.3;
  const mockMinerador = 64.3;
  /** A ferramenta comum e a de ouro de cada recurso. */
  const FERRAMENTAS = { madeira: ['hatchet', 'golden-hatchet'], minerio: ['pickaxe', 'golden-pickaxe'] } as const;
  /** As tabelas padrão do servidor (ColetaCatalog): material, item, skill mínima, faixa de acerto, raridade. */
  const TABELAS_COLETA: Record<'madeira' | 'minerio', [string, string, number, number, number, number][]> = {
    madeira: [
      ['wood', 'log', 0, -25, 75, 49], ['oak', 'oak-log', 65, 25, 105, 30], ['ash', 'ash-log', 80, 40, 120, 10],
      ['yew', 'yew-log', 95, 55, 135, 5], ['heartwood', 'heartwood-log', 100, 60, 140, 3],
      ['bloodwood', 'bloodwood-log', 100, 60, 140, 2], ['frostwood', 'frostwood-log', 100, 60, 140, 1]
    ],
    minerio: [
      ['iron', 'iron-ingot', 0, -25, 75, 50], ['dull-copper', 'dull-copper-ingot', 65, 25, 105, 11],
      ['shadow-iron', 'shadow-iron-ingot', 70, 30, 110, 10], ['copper', 'copper-ingot', 75, 35, 115, 8],
      ['bronze', 'bronze-ingot', 80, 40, 120, 7], ['golden', 'golden-ingot', 85, 45, 125, 6],
      ['agapite', 'agapite-ingot', 90, 50, 130, 4], ['verite', 'verite-ingot', 95, 55, 135, 3],
      ['valorite', 'valorite-ingot', 99, 59, 139, 1]
    ]
  };
  let mockFiltro = ['silver', 'bone'];
  let casaMock: MinhaCasa | null = null;
  /* Testes de navegador (techspec-casa-interface-e-baus): `window.__casaMock.dar(modelo)` dá a casa e mobília na mochila. */
  if (typeof window !== 'undefined')
    (window as unknown as { __casaMock?: unknown }).__casaMock = {
      dar(modeloId: string) {
        const m = MODELOS_MOCK.find(x => x.id === modeloId);
        if (!m) return null;
        const numero = PRIMEIRO_LOTE[m.classe];
        casaMock = { id: `minoc-village-${numero}`, numero, classe: m.classe, modelo: m.id, mapa: 'minoc-village', lugar: 'Vilarejo de Minoc',
          soleiraX: SOLEIRA_MOCK[m.classe][0], soleiraY: SOLEIRA_MOCK[m.classe][1], maxConvidados: m.convidados, convidados: [] };
        for (const [defId, qty] of [['mobilia-bau-metal', 1], ['mobilia-cadeira', 2], ['mobilia-trono', 1], ['mobilia-mesa-grande', 1], ['mobilia-lanterna', 1]] as const)
          for (let k = 0; k < qty; k++)
            bag.push({ id: `i${nextItem++}`, defId, name: t(`item.${defId}`), qty: 1, dur: null, durMax: null, weight: 0, equippedSlot: null });
        return { soleira: SOLEIRA_MOCK[m.classe], lote: LOTE_MOCK[m.classe] };
      }
    };
  let bankSilver = 0;
  let bankGold = 0;
  /** Desconta do cofre primeiro, depois da prata da mochila (como o Leilão do servidor). */
  function pagarPrata(n: number) {
    const doCofre = Math.min(bankSilver, n);
    bankSilver -= doCofre;
    let resto = n - doCofre;
    for (const i of bag) {
      if (resto <= 0) break;
      if (i.defId !== 'silver' || i.equippedSlot) continue;
      const tira = Math.min(i.qty, resto);
      i.qty -= tira;
      resto -= tira;
    }
    for (let k = bag.length - 1; k >= 0; k--) if (bag[k].defId === 'silver' && bag[k].qty <= 0) bag.splice(k, 1);
  }
  const mercado = mockMercado(
    () => ({ cofre: bankSilver, mochila: bag.filter(i => i.defId === 'silver' && !i.equippedSlot).reduce((s, i) => s + i.qty, 0) }),
    pagarPrata,
    () => chars.find(c => c.shardId === activeShard)?.name ?? 'Você'
  );
  // Menu de vendas (techspec-vendas): o que vendeu fica 15 min para recomprar.
  const vendasMock: { id: string; defId: string; nome: string; qty: number; dur: number | null; durMax: number | null; peso: number; valor: number; ate: number; feita: boolean }[] = [];
  const travasMock = new Map<string, boolean>();
  let vendaSeq = 1;
  let vendaDemo = false;
  const vault: MutableBank[] = [];
  let nextBank = 1;

  /** O catálogo do corretor (Houses/CasaModelos.cs), de graça como no servidor com `casas.gratis`. */
  const MODELOS_MOCK: readonly HouseModelo[] = ([
    ['palha', 'P', 8, 8, 1, false, 140000, 2300, 45, 2, 1, 4], ['madeira', 'P', 8, 8, 1, false, 150000, 2500, 50, 2, 1, 4],
    ['madeira-reboco', 'P', 8, 8, 1, false, 170000, 2800, 55, 3, 1, 4], ['pedra-reboco', 'P', 8, 8, 1, false, 180000, 3000, 60, 3, 1, 4],
    ['pedra-campo', 'P', 8, 8, 1, false, 190000, 3100, 60, 3, 1, 4], ['tijolo', 'P', 8, 8, 1, false, 200000, 3400, 70, 3, 1, 4],
    ['loja-pedra', 'P', 8, 8, 2, false, 420000, 7000, 120, 4, 1, 6], ['loja-marmore', 'P', 7, 8, 2, true, 520000, 8500, 150, 5, 1, 6],
    ['torre-pequena', 'P', 8, 8, 2, true, 650000, 10000, 170, 6, 2, 8], ['cabana', 'M', 8, 14, 2, false, 480000, 8000, 150, 5, 1, 8],
    ['patio-arenito', 'M', 12, 10, 1, true, 520000, 8500, 160, 5, 1, 8], ['villa', 'M', 12, 12, 2, false, 900000, 15000, 240, 7, 2, 10],
    ['tijolo-grande', 'G', 15, 15, 1, false, 1100000, 18000, 260, 8, 2, 12], ['patio-grande', 'G', 16, 15, 1, false, 1200000, 19000, 280, 8, 2, 12],
    ['dois-andares-madeira', 'G', 15, 15, 2, false, 1400000, 22000, 300, 9, 2, 12], ['dois-andares-pedra', 'G', 15, 15, 2, false, 1500000, 24000, 310, 9, 2, 12],
    ['marmore', 'G', 15, 15, 2, true, 2200000, 33000, 400, 12, 2, 15], ['torre', 'L', 24, 16, 3, true, 4500000, 65000, 650, 16, 3, 20],
    ['fortaleza', 'L', 24, 24, 2, true, 8000000, 110000, 900, 22, 3, 25]
  ] as const).map(([id, classe, largura, altura, andares, terraco, preco, aluguel, presos, baus, manequins, convidados]) => ({
    id, classe, largura, altura, andares, terraco, preco, precoAgora: 0, aluguel, presos, baus, manequins, convidados,
    livres: { P: 25, M: 12, G: 9, L: 2 }[classe]
  }));
  const PRIMEIRO_LOTE = { P: 1, M: 26, G: 38, L: 47 } as const;
  /* Itens presos e baús do modo offline (techspec-casas §04). Sem posição do servidor: o ponto vem do cliente. */
  let casaPresosMock: CasaPreso[] = [];
  let casaBausMock: CasaBau[] = [];
  /* techspec-casa-interface-e-baus: os baús são itens (o comum grátis e os comprados), com vagas e teto pelo item. */
  const BAU_COMUM_MOCK = 'mobilia-bau-comum';
  const vagasDoBauMock = (defId: string) => { const d = MOBILIA.find(x => x.id === defId); return d?.gratis ? 20 : d?.raridade === 1 ? 40 : 30; };
  const comVagas = (b: CasaBau): CasaBau => ({ ...b, vagas: vagasDoBauMock(b.defId ?? BAU_COMUM_MOCK), usadas: b.itens.length });
  let nomeCasaMock: string | null = null;
  const novoBauMock = (defId: string, ponto: { x: number; y: number; z: number; giro?: number }) => {
    const m = casaDoMock();
    if (casaBausMock.length >= m.baus) throw new ApiError('A casa não aceita mais baús.', 409, 'casa.cheiaBaus');
    const teto = MOBILIA.find(x => x.id === defId)?.gratis ? 4 : 0;
    if (teto && casaBausMock.filter(b => b.defId === defId).length >= teto) throw new ApiError('A casa já tem o máximo deste baú.', 409, 'casa.tetoBau');
    pontoLivreMock(ponto, alturaDe(defId));
    casaBausMock.push({ id: `hb${nextCasaItem++}`, defId, x: ponto.x, y: ponto.y, z: ponto.z, giro: Math.max(0, Math.min(1, ponto.giro ?? 0)), itens: [], perm: 3, rotulo: null, trancado: false });
  };
  let nextCasaItem = 1;
  const casaDoMock = () => {
    if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
    if (!casaMock) throw new ApiError(t('casa.semCasa'), 409, 'casa.semCasa');
    const m = MODELOS_MOCK.find(x => x.id === casaMock!.modelo);
    if (!m) throw new ApiError('Erga uma casa no lote antes.', 409, 'casa.semModelo');
    return m;
  };
  const casaItensMock = (): CasaItens => {
    const m = MODELOS_MOCK.find(x => x.id === casaMock?.modelo);
    // As ferramentas de ofício (techspec-marceneiro-e-oficios-em-casa §04.1) saem dos presos e vão para a própria lista.
    const oficios: CasaOficio[] = casaPresosMock.filter(p => oficioDe(p.defId)).map(p => ({
      id: p.id, defId: p.defId, nome: p.nome, oficio: oficioDe(p.defId)!, x: p.x, y: p.y, z: p.z, giro: p.giro ?? 0,
      altura: alturaDe(p.defId), bonusAtivo: true, motivo: null
    }));
    return {
      presos: casaPresosMock.filter(p => !oficioDe(p.defId)), baus: casaBausMock.map(comVagas), maxPresos: m?.presos ?? 0, maxBaus: m?.baus ?? 0,
      vagasPorBau: vagasDoBauMock(BAU_COMUM_MOCK), alcance: 0, papel: 'dono', oficios, maxOficios: VAGAS_OFICIO_MOCK(m?.id ?? ''), alturaDoMuro: ALTURA_DO_MURO,
      tetosDeBau: Object.fromEntries(MOBILIA.filter(x => x.bau).map(x => [x.id, x.gratis ? 4 : 0])), quase: 80, nome: nomeCasaMock
    };
  };
  const pontoLivreMock = (p: { x: number; y: number; z: number }, altura = 1, ignorar?: string) => {
    if (casaPresosMock.some(i => i.id !== ignorar && i.x === p.x && i.y === p.y && cruzam(p.z, altura, i.z, alturaDe(i.defId)))
      || casaBausMock.some(b => b.id !== ignorar && b.x === p.x && b.y === p.y && cruzam(p.z, altura, b.z, alturaDe(b.defId ?? BAU_COMUM_MOCK))))
      throw new ApiError('Já tem algo nesse lugar.', 409, 'casa.ocupado');
  };
  const tirarDoBagMock = (item: MutablePack, qty: number) => {
    if (qty >= item.qty) bag.splice(bag.indexOf(item), 1);
    else item.qty -= qty;
  };
  const SOLEIRA_MOCK = { P: [9, 15], M: [73, 21], G: [12, 85], L: [81, 93] } as const;
  /** O primeiro lote de cada classe (mapas/fonte/minoc-village/lotes.json). */
  const LOTE_MOCK = {
    P: { x0: 5, y0: 5, x1: 14, y1: 14 }, M: { x0: 67, y0: 5, x1: 80, y1: 20 },
    G: { x0: 4, y0: 67, x1: 21, y1: 84 }, L: { x0: 69, y0: 67, x1: 94, y1: 92 }
  } as const;

  const catalogoMock = (): readonly HouseModelo[] =>
    MODELOS_MOCK.map(m => (casaMock && casaMock.classe === m.classe ? { ...m, livres: m.livres - 1 } : m));

  const LOJA_MAGO = ['empty-bottle', 'mortar-pestle'] as const;

  function mockNpcShop(npcId: string): NpcShop {
    return {
      npcId,
      moeda: 'silver',
      itens: LOJA_MAGO.map(id => {
        const def = MOCK_ITEM_DEFS.get(id)!;
        return { defId: id, nome: def.name, preco: 4, peso: def.weight };
      })
    };
  }

  return {
    async signIn({ email, password, serial }: Credentials): Promise<Account> {
      await wait(420);
      if (!looksLikeEmail(email.trim()) || password.length < 8) {
        throw new ApiError(t('auth.badCredentials'), 401, 'auth.badCredentials');
      }
      // No mock, e-mails que começam com "semacesso" não têm acesso à fase; com um código, entram.
      if (email.trim().toLowerCase().startsWith('semacesso') && !serial)
        throw new ApiError(t('acesso.semAcesso'), 403, 'acesso.semAcesso');
      if (pendentes.has(email.trim().toLowerCase())) throw new ApiError(t(CONFIRMAR_EMAIL), 403, CONFIRMAR_EMAIL);
      // No mock, e-mails que começam com "gm" são da equipe: pedem o código do app (sempre 123456; recuperação ABCDE-23456).
      if (email.trim().toLowerCase().startsWith('gm')) {
        desafios.set('mock-' + email.trim().toLowerCase(), email.trim());
        throw new DesafioDoisFatores('mock-' + email.trim().toLowerCase());
      }
      session = fromEmail(email.trim());
      return session;
    },

    async signIn2fa({ desafio, codigo, recuperacao }): Promise<Account> {
      await wait(300);
      const email = desafios.get(desafio);
      if (!email) throw new ApiError(t(DOIS_FATORES_DESAFIO), 401, DOIS_FATORES_DESAFIO);
      if (codigo !== '123456' && (recuperacao ?? '').replace('-', '').toUpperCase() !== 'ABCDE23456')
        throw new ApiError(t('auth.doisFatoresCodigo'), 401, 'auth.doisFatoresCodigo');
      desafios.delete(desafio);
      session = fromEmail(email);
      return session;
    },

    async estadoAcesso() {
      // O mock lê a URL para os testes da landing (tests/landing.mjs). Nunca vai à produção:
      // o build de produção fala com a API (api/mode.ts).
      const q = new URLSearchParams(window.location.search);
      if (q.get('mock-estado') === 'falha') throw new ApiError(t('auth.unavailable'), 0);
      const fase = (nome: string | null) => nome ? { nome, tipo: 'alpha', comecaEm: '2026-11-03T00:00:00Z' } : null;
      return {
        inscricoesAbertas: q.get('mock-fechado') !== '1',
        restrito: q.get('mock-restrito') === '1',
        fase: fase(q.get('mock-fase')),
        proxima: q.get('mock-fase') ? null : fase(q.get('mock-proxima')),
        antiRobo: q.get('mock-antirobo') ? { chaveSite: q.get('mock-antirobo')! } : null,
        redes: { instagram: 'https://www.instagram.com/ultimaidle/', instagramUsuario: 'ultimaidle', discord: 'https://discord.gg/7mwCCQdy3M' }
      };
    },

    async inscreverAcesso() {
      await wait(200);
      const falha = Number(new URLSearchParams(window.location.search).get('mock-inscricao') ?? 0);
      if (falha === 409) throw new ApiError(t('landing.fechado.titulo'), 409, 'acesso.inscricoesFechadas');
      if (falha === 429) throw new ApiError(t('auth.rateLimited'), 429, 'auth.rateLimited');
      if (falha === 400) throw new ApiError(t('landing.form.erroAntiRobo'), 400, 'acesso.antiRobo');
      if (falha >= 500) throw new ApiError(t('auth.unavailable'), falha);
      return { message: t('acesso.enviado') };
    },

    async confirmarAcesso() {
      await wait(200);
      return { fase: null as string | null };
    },

    async sairDaLista() {
      await wait(200);
      return { ok: true };
    },

    async reenviarConvite() {
      await wait(200);
      return { message: t('acesso.enviado') };
    },

    ...criarMockFounders(),
    ...correioMock,
    ...topidleMock,
    ...criarMockIndicacoes(),
    ...criarMockParceiros(),

    async signInGoogle(): Promise<Account> {
      throw new ApiError('O login com Google só funciona com o servidor (VITE_API_MODE=http).', 503);
    },

    async signUp({ email, password, serial }: Credentials): Promise<Account> {
      await wait(420);
      if (!looksLikeEmail(email.trim()) || password.length < 8) {
        throw new ApiError(t('auth.invalidEmail'), 400, 'auth.invalidEmail');
      }
      // Fase de testes (?mock-restrito=1): conta nova só com o código do convite (techspec-landing-fase §06.7).
      if (new URLSearchParams(window.location.search).get('mock-restrito') === '1' && !serial)
        throw new ApiError(t('acesso.soConvite'), 403, 'acesso.soConvite');
      // No mock, só e-mails que começam com "confirmar" pedem o código (sempre 123456): o resto entra na hora.
      if (email.trim().toLowerCase().startsWith('confirmar')) {
        pendentes.add(email.trim().toLowerCase());
        throw new ApiError(t(CONFIRMAR_EMAIL), 202, CONFIRMAR_EMAIL);
      }
      session = fromEmail(email.trim());
      return session;
    },

    async confirmarEmail({ email, codigo }): Promise<Account> {
      await wait(420);
      const chave = email.trim().toLowerCase();
      if (!pendentes.has(chave)) throw new ApiError(t('auth.emailJaConfirmado'), 409, 'auth.emailJaConfirmado');
      if (codigo.trim() !== '123456') throw new ApiError(t('auth.codigoInvalido'), 400, 'auth.codigoInvalido');
      pendentes.delete(chave);
      session = fromEmail(email.trim());
      return session;
    },

    async reenviarCodigo(): Promise<void> {
      await wait(300);
    },

    // "Esqueci a senha" no mock: o código é sempre 123456 e qualquer e-mail serve.
    async esqueciSenha(): Promise<void> {
      await wait(300);
    },

    async redefinirSenha({ email, codigo, senha }): Promise<Account> {
      await wait(420);
      if (codigo.trim() !== '123456') throw new ApiError(t('auth.codigoInvalido'), 400, 'auth.codigoInvalido');
      if (senha.length < 8) throw new ApiError(t('auth.passwordShort'), 400);
      session = fromEmail(email.trim());
      return session;
    },

    async me(): Promise<Account> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return session;
    },

    async gravarIdioma(idioma: string): Promise<void> {
      if (session) session = { ...session, idioma };
    },

    async signOut(): Promise<void> {
      await wait(80);
      session = null;
    },

    async listShards(): Promise<readonly Shard[]> {
      await wait(260);
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return SHARDS;
    },

    async listCharacters(shardId: string): Promise<readonly CharacterSummary[]> {
      await wait(200);
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      activeShard = shardId;
      return listed(shardId);
    },

    async creationCatalog(): Promise<CreationCatalog> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return MOCK_CATALOG;
    },

    async createCharacter(shardId: string, draft: CharacterDraft, key: string): Promise<CharacterSummary> {
      await wait(280);
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const replay = idem.get(key);
      if (replay) {
        const found = chars.find(c => c.id === replay);
        if (found) return found;
      }
      const shard = SHARDS.find(s => s.id === shardId);
      if (!shard) throw new ApiError('Este shard não existe.', 404);
      if (shard.status !== 'aberto') throw new ApiError('Este shard não aceita novos personagens.', 409);
      if (listed(shardId).length >= 5) throw new ApiError('Você já tem 5 personagens neste shard.', 409);
      const name = normalizeName(draft.name);
      if (name.length < 2 || name.length > 16) throw new ApiError('O nome precisa ter entre 2 e 16 caracteres.', 400);
      if (chars.some(c => c.shardId === shardId && c.name.toLowerCase() === name.toLowerCase())) {
        throw new ApiError('Este nome já vive neste shard.', 409);
      }
      const profession = MOCK_CATALOG.professions.find(p => p.id === draft.profession);
      const skills = profession?.skills ?? draft.skills;
      const id = `c${nextId++}`;
      const row: CharacterSummary = {
        id, shardId, name,
        profession: profession?.label ?? 'Avançado',
        skillTotal: skills.reduce((s, x) => s + x.value, 0),
        homeCity: MOCK_CATALOG.cities.find(c => c.id === draft.homeCity)?.label ?? draft.homeCity,
        notoriety: 'inocente',
        lastSeen: 'agora',
        skin: 'human-male',
        skinHue: draft.appearance.skinHue,
        dead: false,
        tutorial: true
      };
      chars.push(row);
      details.set(id, {
        ...row,
        sex: draft.sex,
        stats: profession?.stats ?? draft.stats,
        skills,
        appearance: { ...draft.appearance }
      });
      idem.set(key, id);
      return row;
    },

    async getCharacter(shardId: string, id: string): Promise<CharacterDetail> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const row = details.get(id);
      if (!row || row.shardId !== shardId) throw new ApiError('Personagem não encontrado.', 404);
      return row;
    },

    async updateAppearance(shardId: string, id: string, patch: CosmeticPatch): Promise<Appearance> {
      await wait(120);
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const row = details.get(id);
      if (!row || row.shardId !== shardId) throw new ApiError('Personagem não encontrado.', 404);
      const next: Appearance = {
        ...row.appearance,
        hairStyle: patch.hairStyle,
        hairHue: patch.hairHue,
        beardStyle: row.sex === 'female' ? null : patch.beardStyle,
        beardHue: row.sex === 'female' ? null : patch.beardHue,
        shirtHue: patch.shirtHue,
        pantsHue: patch.pantsHue
      };
      details.set(id, { ...row, appearance: next });
      return next;
    },

    async deleteCharacter(shardId: string, id: string, name: string): Promise<void> {
      await wait(160);
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const idx = chars.findIndex(c => c.id === id && c.shardId === shardId);
      if (idx < 0) throw new ApiError('Personagem não encontrado.', 404);
      if (normalizeName(name).toLowerCase() !== chars[idx].name.toLowerCase()) {
        throw new ApiError('O nome não confere.', 400);
      }
      chars.splice(idx, 1);
      details.delete(id);
    },

    async concluirTutorial(shardId: string, id: string): Promise<void> {
      const row = chars.find(c => c.id === id && c.shardId === shardId);
      if (row) (row as { tutorial?: boolean }).tutorial = false;
      const detail = details.get(id);
      if (detail) (detail as { tutorial?: boolean }).tutorial = false;
    },

    async listFriends(): Promise<readonly Friend[]> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return friends.slice();
    },

    async lookupFriend(name: string): Promise<FriendLookup> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const n = normalizeName(name);
      const hit = chars.find(c =>
        c.shardId === activeShard && c.name.toLowerCase() === n.toLowerCase());
      if (!hit) throw new ApiError('Ninguém com esse nome neste shard.', 404);
      return { name: hit.name, online: hit.name === 'Corvus' || hit.name === 'Aldric' };
    },

    async addFriend(name: string): Promise<Friend> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const found = await this.lookupFriend(name);
      const already = friends.find(f => f.name.toLowerCase() === found.name.toLowerCase());
      if (already) return already;
      if (friends.length >= 50) throw new ApiError('Sua lista de amigos está cheia.', 409);
      const row = chars.find(c => c.shardId === activeShard && c.name === found.name);
      const next: Friend = { id: row?.id ?? `f-${friends.length}`, name: found.name, online: found.online };
      friends.push(next);
      return next;
    },

    async removeFriend(characterId: string): Promise<void> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const idx = friends.findIndex(f => f.id === characterId);
      if (idx >= 0) friends.splice(idx, 1);
    },

    async suporteAbrir(body: SuporteNovo): Promise<{ numero: number }> {
      if (!session) throw new ApiError(t('auth.sessionExpired'), 401);
      await wait(250);
      const agora = Date.now();
      while (suporteHora.length && agora - suporteHora[0] > 3_600_000) suporteHora.shift();
      if (suporteHora.length >= 5 || new URLSearchParams(window.location.search).get('mock-suporte') === 'limite')
        throw new ApiError(t('suporte.limite'), 429, 'suporte.limite');
      if (body.titulo.trim().length < 6) throw new ApiError(t('suporte.titulo'), 400, 'suporte.titulo');
      if (body.relato.trim().length < 20) throw new ApiError(t('suporte.relato'), 400, 'suporte.relato');
      suporteHora.push(agora);
      const numero = suporteSeq++;
      suporte.unshift({
        numero, tipo: body.tipo, assunto: body.assunto, titulo: body.titulo.trim(), relato: body.relato.trim(),
        frequencia: body.frequencia, situacao: 'recebido', criadoEm: new Date(agora).toISOString(),
        analiseEm: null, pedidoEm: null, finalizadoEm: null, conversa: []
      });
      return { numero };
    },

    async suporteMeus(): Promise<readonly SuporteChamado[]> {
      if (!session) throw new ApiError(t('auth.sessionExpired'), 401);
      await wait(120);
      return suporte.map(c => ({ ...c, conversa: [...c.conversa] }));
    },

    async suporteResumo() {
      return { precisaDeVoce: suporte.filter(c => c.situacao === 'contato').length };
    },

    async rankingTabela(tipo, periodo, ordem, busca) {
      await wait(120);
      return mockTabela(tipo, periodo, ordem, busca);
    },

    async rankingMinhas() {
      await wait(120);
      return mockMinhas();
    },

    async rankingRegras() {
      await wait(80);
      return mockRegras();
    },

    async wikiDados() {
      await wait(150);
      // Retrato real de GET /api/wiki/v1 (banco de teste): só carrega quando a Wiki abre.
      return (await import('./mockWiki')).MOCK_WIKI;
    },

    async suporteResponder(numero: number, texto: string): Promise<void> {
      await wait(150);
      const i = suporte.findIndex(c => c.numero === numero);
      if (i < 0) throw new ApiError(t('suporte.naoAchado'), 404, 'suporte.naoAchado');
      if (suporte[i].situacao !== 'contato') throw new ApiError(t('suporte.naoAguarda'), 409, 'suporte.naoAguarda');
      if (texto.trim().length < 10) throw new ApiError(t('suporte.resposta'), 400, 'suporte.resposta');
      suporte[i] = {
        ...suporte[i], situacao: 'analise', pedidoEm: null,
        conversa: [...suporte[i].conversa, { de: 'voce', texto: texto.trim(), em: new Date().toISOString() }]
      };
    },

    async reportPlayer(name: string, reason: string): Promise<{ id: string }> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const n = normalizeName(name);
      if (n.toLowerCase() === session.displayName.toLowerCase()) {
        throw new ApiError('Você não pode denunciar a si mesmo.', 400);
      }
      if (reason.trim().length < 10) {
        throw new ApiError('Escreva o motivo da denúncia.', 400);
      }
      return { id: `r-${++nextId}` };
    },

    async itemCatalog() {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return MOCK_ITEM_CATALOG;
    },

    async getPack(): Promise<Pack> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return snapshot();
    },

    async loja(): Promise<LojaVitrine> {
      return {
        aberta: true,
        textos: {
          titulo: { pt: 'Loja' },
          fechada: { pt: 'A loja está fechada.' },
          reembolso: { pt: 'O ouro volta para o banco.' }
        },
        abas: [],
        pacotes: []
      };
    },

    async comprarLoja(): Promise<LojaCompra> {
      throw new ApiError('A loja de demonstração não vende.', 400);
    },

    async pedidosLoja() {
      return [];
    },

    // A aba Ouro de demonstração: o Pix "paga" sozinho na terceira consulta e nada é cobrado.
    async lojaOuro() {
      return {
        vendaAberta: true, motivo: null, codigo: null, ambiente: 'teste' as const, metodos: ['pix', 'cartao'],
        // ?mock-pag=simulado: a tela do pagamento simulado do ambiente local (techspec-pagamentos-simulados).
        simulado: mockParam('mock-pag') === 'simulado',
        parcelasMax: 3,
        pacotes: [{ id: 'ouro-300', ouro: 300, centavos: 490 }, { id: 'ouro-1000', ouro: 1000, centavos: 1490 }, { id: 'ouro-3000', ouro: 3000, centavos: 3990 }],
        semana: { limiteOuro: 3000, usadoOuro: 0 }, pixExpiraMin: 30, pixConsultaS: 3,
        politica: { versao: '1', texto: 'Demonstração: nada é cobrado.' },
        aviso18: 'Só para maiores de 18 anos ou com o responsável.', bloqueio: null,
        personagem: null, pendentes: []
      };
    },

    async pedirOuro(body) {
      const pac = ({ 'ouro-300': [300, 490], 'ouro-1000': [1000, 1490], 'ouro-3000': [3000, 3990] } as Record<string, [number, number]>)[body.pacoteId];
      if (!pac) throw new ApiError('Esse pacote não está mais à venda.', 409, 'PacoteSumiu');
      // Pix ou cartão: os dois aguardam e "pagam" sozinhos na terceira consulta (o cartão, na janela do Mercado Pago).
      mockPix = { id: body.chave, consultas: 0, ouro: pac[0], centavos: pac[1], estado: 'aguardando', metodo: body.metodo };
      return pixDoMock();
    },

    async pedidoOuro() {
      if (!mockPix) throw new ApiError('Pedido não encontrado.', 404);
      if (mockPix.estado === 'aguardando' && ++mockPix.consultas >= 3) mockPix.estado = 'pago';
      return pixDoMock();
    },

    async historicoOuro() {
      if (!mockPix || mockPix.estado !== 'pago') return [];
      return [{ id: mockPix.id, estado: 'pago', metodo: 'pix', ouro: mockPix.ouro, centavos: mockPix.centavos,
        criadoEm: new Date().toISOString(), pagoEm: new Date().toISOString(), personagem: null }];
    },

    async cancelarOuro() {
      if (!mockPix || mockPix.estado !== 'aguardando') throw new ApiError('Este pedido não pode mais ser cancelado.', 409, 'NaoCancela');
      mockPix.estado = 'cancelado';
      return pixDoMock();
    },

    async vip() {
      return { ate: 0, mostrar: true, ativo: false, banco: 0, precos: { 'greater-healing': 75, 'cure-poison': 35 } };
    },

    async vipMostrar() {},

    // Discord (techspec-discord-cargos): no mock, o vincular só liga a seção (não vai ao Discord).
    async discordEstado() { return { ...mockDiscord, cargos: [...mockDiscord.cargos] }; },
    async discordVincular() {
      mockDiscord = { ...mockDiscord, vinculado: true, cargos: ['VIP'], pendente: false, erro: null, sincronizadoEm: Date.now() };
      return { url: '/?discord=ok' };
    },
    async discordAtualizar() { return { ...mockDiscord, sincronizadoEm: Date.now() }; },
    async discordDesvincular() { mockDiscord = { ...mockDiscord, vinculado: false, cargos: [], erro: null, sincronizadoEm: null }; },
    // O botão só aparece no mock com ?mock-discord=1 (não muda as telas dos testes de navegador).
    async discordLoginAtivo() {
      try { return { ativo: new URLSearchParams(window.location.search).get('mock-discord') === '1' }; } catch { return { ativo: false }; }
    },
    async discordEntrar() { return { url: '/?discordLogin=erro&motivo=auth.discord.desligado' }; },

    async oficinaMenu(oficio: Oficio): Promise<OficinaMenu> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return mockOficinaMenu(oficio, bag);
    },

    async oficinaFazer(oficio: Oficio, defId: string, material: string): Promise<OficinaFeito> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const of = OFICINA_DO[oficio];
      const pre = of.pre;
      const receita = OFICINA_RECEITAS.find(r => r.defId === defId && r.oficio === oficio);
      if (!receita) throw new ApiError(tMock(`${pre}.receitaDesconhecida`), 400, `${pre}.receitaDesconhecida`);
      const mat = OFICINA_MATERIAIS.find(m => m.id === material && m.familia === of.familia);
      if (!mat) throw new ApiError(tMock('oficina.materialErrado'), 400, 'oficina.materialErrado');
      const pericia = of.pericia();
      const codMat = { ferraria: 'ferraria.periciaMetal', arcos: 'arcos.periciaMadeira', alfaiataria: 'alfaiataria.periciaCouro' }[oficio];
      if (pericia < mat.pericia) throw new ApiError(tMock(codMat), 409, codMat);
      if (pericia < receita.pericia)
        throw new ApiError(tMock(`${pre}.periciaBaixa`), 409, `${pre}.periciaBaixa`);
      if (of.ferramenta && !bag.some(i => i.defId === of.ferramenta && !i.equippedSlot)) {
        const cod = oficio === 'alfaiataria' ? 'alfaiataria.semKit' : 'arcos.semFerramenta';
        throw new ApiError(tMock(cod), 409, cod);
      }
      const livre = somaSolta(bag, mat.insumo);
      const codFalta = { ferraria: 'ferraria.semLingote', arcos: 'arcos.semMaterial', alfaiataria: 'alfaiataria.semMaterial' }[oficio];
      if (livre < receita.qtd) throw new ApiError(tMock(codFalta), 409, codFalta);
      const peso = MOCK_ITEM_DEFS.get(mat.insumo)?.weight ?? 0;
      gastarMock(bag, mat.insumo, receita.qtd, peso);
      const feito = MOCK_ITEM_DEFS.get(idDaVariante(defId, mat.id)) ?? MOCK_ITEM_DEFS.get(defId);
      const exigida = Math.max(receita.pericia, mat.pericia);
      const qualidade = Math.random() * 100 < chanceMock(pericia, exigida) ? 2 : 1;
      const id = `i${nextItem++}`;
      bag.push({
        id, defId: feito?.id ?? defId, name: feito?.name ?? defId, qty: 1, dur: 60, durMax: 60,
        weight: feito?.weight ?? 1, equippedSlot: null, material: mat.id, qualidade, feitoPor: MOCK_NOME
      });
      return { pack: snapshot(), prontoEmMs: Math.random() < 0.5 ? 1700 : 3400, itemId: id, defId: feito?.id ?? defId, qualidade, feitoPor: MOCK_NOME };
    },


    async tailorMenu(): Promise<TailorMenu> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return mockTailorMenu(bag);
    },

    async sew(defId: string): Promise<Craft> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const receita = TAILOR_RECIPES.find(r => r.defId === defId);
      if (!receita) throw new ApiError(tMock('alfaiataria.receitaDesconhecida'), 400, 'alfaiataria.receitaDesconhecida');
      const alfaiataria = MOCK_ALFAIATARIA;
      if (alfaiataria < receita.skill)
        throw new ApiError(tMock('alfaiataria.periciaBaixa'), 409, 'alfaiataria.periciaBaixa');
      const def = MOCK_ITEM_DEFS.get(receita.defId);
      if (!def) throw new ApiError(tMock('alfaiataria.receitaDesconhecida'), 400, 'alfaiataria.receitaDesconhecida');
      if (!bag.some(i => i.defId === 'sewing-kit' && !i.equippedSlot))
        throw new ApiError(tMock('alfaiataria.semKit'), 409, 'alfaiataria.semKit');
      const tenho = somaSolta(bag, receita.material);
      if (tenho < receita.qtd)
        throw new ApiError(tMock('alfaiataria.semMaterial'), 409, 'alfaiataria.semMaterial');
      const pesoMat = MOCK_ITEM_DEFS.get(receita.material)?.weight ?? 0.1;
      if (weightOf(bag) - receita.qtd * pesoMat + def.weight * receita.rende > weightMax)
        throw new ApiError(tMock('alfaiataria.semPeso'), 409, 'alfaiataria.semPeso');
      gastarMock(bag, receita.material, receita.qtd, pesoMat);
      if (def.stackable) {
        empilharMock(bag, def.id, receita.rende, def.weight, q => ({
          id: `i${nextItem++}`, defId: def.id, name: def.name, qty: q, dur: null, durMax: null, weight: def.weight * q, equippedSlot: null
        }));
      } else {
        bag.push({
          id: `i${nextItem++}`,
          defId: def.id,
          name: def.name,
          qty: 1,
          dur: 60,
          durMax: 60,
          weight: def.weight,
          equippedSlot: null
        });
      }
      return { pack: snapshot(), prontoEmMs: 4500 };
    },

    async fletchMenu(): Promise<FletchMenu> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return mockFletchMenu(bag);
    },

    async carve(defId: string): Promise<Craft> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const receita = FLETCH_RECIPES.find(r => r.defId === defId);
      if (!receita) throw new ApiError(tMock('arcos.receitaDesconhecida'), 400, 'arcos.receitaDesconhecida');
      const arcos = MOCK_ARCOS;
      if (arcos < receita.skill)
        throw new ApiError(tMock('arcos.periciaBaixa'), 409, 'arcos.periciaBaixa');
      const def = MOCK_ITEM_DEFS.get(receita.defId);
      if (!def) throw new ApiError(tMock('arcos.receitaDesconhecida'), 400, 'arcos.receitaDesconhecida');
      if (!bag.some(i => i.defId === 'fletcher-tools' && !i.equippedSlot))
        throw new ApiError(tMock('arcos.semFerramenta'), 409, 'arcos.semFerramenta');
      for (const ins of receita.insumos) {
        if (somaSolta(bag, ins.defId) < ins.qtd)
          throw new ApiError(tMock('arcos.semMaterial'), 409, 'arcos.semMaterial');
      }
      const sai = receita.insumos.reduce((acc, ins) => {
        const peso = MOCK_ITEM_DEFS.get(ins.defId)?.weight ?? 0.1;
        return acc + ins.qtd * peso;
      }, 0);
      if (weightOf(bag) - sai + def.weight * receita.rende > weightMax)
        throw new ApiError(tMock('arcos.semPeso'), 409, 'arcos.semPeso');
      for (const ins of receita.insumos) {
        const peso = MOCK_ITEM_DEFS.get(ins.defId)?.weight ?? 0.1;
        gastarMock(bag, ins.defId, ins.qtd, peso);
      }
      if (def.stackable) {
        empilharMock(bag, def.id, receita.rende, def.weight, q => ({
          id: `i${nextItem++}`, defId: def.id, name: def.name, qty: q, dur: null, durMax: null, weight: def.weight * q, equippedSlot: null
        }));
      } else {
        bag.push({
          id: `i${nextItem++}`,
          defId: def.id,
          name: def.name,
          qty: 1,
          dur: 60,
          durMax: 60,
          weight: def.weight,
          equippedSlot: null
        });
      }
      return { pack: snapshot(), prontoEmMs: 1700 };
    },

    async vendas(): Promise<VendaJanela> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!vendaDemo) {
        vendaDemo = true;
        // O mock nasce de mochila vazia: na primeira abertura entra um saque de cemitério.
        if (!bag.some(i => MOCK_VENDA_PRECO[i.defId])) semearVendaDemo();
      }
      const agora = Date.now();
      const itens: VendaItem[] = bag
        .filter(i => i.defId !== 'silver' && i.defId !== 'gold')
        .map(i => {
          const preco = MOCK_VENDA_PRECO[i.defId] ?? null;
          const grupo = grupoMock(i.defId);
          return {
            itemId: i.id,
            defId: i.defId,
            nome: i.name,
            qty: i.qty,
            preco: preco ?? 0,
            compra: preco !== null,
            travado: travasMock.get(i.defId) ?? travaPadraoDaVenda(i.defId, grupo),
            equipado: !!i.equippedSlot,
            preso: 0,
            categoria: categoriaDaVenda(i.defId, grupo),
            loot: MOCK_VENDA_LOOT.has(i.defId),
            dur: i.dur,
            durMax: i.durMax ?? 0,
            peso: i.qty > 0 ? i.weight / i.qty : 0
          };
        })
        .sort((a, b) => Number(a.equipado) - Number(b.equipado) || a.nome.localeCompare(b.nome));
      const prata = bag.filter(i => i.defId === 'silver' && !i.equippedSlot).reduce((s, i) => s + i.qty, 0);
      return {
        aberta: true,
        motivo: null,
        cidade: 'Minoc',
        itens,
        recompras: vendasMock
          .filter(v => !v.feita && v.ate > agora)
          .map(v => ({ id: v.id, defId: v.defId, nome: v.nome, qty: v.qty, valor: v.valor, ate: new Date(v.ate).toISOString() })),
        regras: { recompraMin: 15, confirmarTotal: 2000, confirmarPeca: 500, destinoPadrao: 'cofre' },
        prataMochila: prata,
        prataCofre: bankSilver
      };
    },

    async vender(body) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      let total = 0;
      const linhas: { row: MutablePack; qty: number; preco: number }[] = [];
      for (const l of body.itens) {
        const row = bag.find(i => i.id === l.itemId);
        if (!row) throw new ApiError('Esse item não está na sua mochila.', 404);
        const preco = MOCK_VENDA_PRECO[row.defId] ?? null;
        if (preco === null) throw new ApiError('A cidade não compra esse item.', 409, 'venda.naoCompra');
        if (row.equippedSlot) throw new ApiError('Tire o item antes de vender.', 409, 'venda.equipado');
        if (travasMock.get(row.defId) ?? travaPadraoDaVenda(row.defId, grupoMock(row.defId)))
          throw new ApiError('Esse item está travado para venda.', 409, 'venda.travado');
        if (l.qty < 1 || l.qty > row.qty) throw new ApiError('Informe uma quantidade válida.', 400);
        total += l.qty * preco;
        linhas.push({ row, qty: l.qty, preco });
      }
      if (body.esperado !== total) throw new ApiError('Os preços mudaram. Confira a lista de novo.', 409, 'venda.precoMudou');
      const sai = linhas.reduce((s, l) => s + l.qty * (l.row.weight / l.row.qty), 0);
      if (body.destino === 'mochila' && weightOf(bag) - sai + total * 0.02 > weightMax)
        throw new ApiError('A prata não cabe na mochila. Mande para o cofre ou venda menos.', 409, 'venda.semPeso');
      const ate = Date.now() + 15 * 60_000;
      for (const { row, qty, preco } of linhas) {
        const peso = row.weight / row.qty;
        vendasMock.unshift({ id: `v${vendaSeq++}`, defId: row.defId, nome: row.name, qty, dur: row.dur, durMax: row.durMax, peso, valor: qty * preco, ate, feita: false });
        if (qty === row.qty) bag.splice(bag.indexOf(row), 1);
        else {
          row.qty -= qty;
          row.weight = row.qty * peso;
        }
      }
      if (body.destino === 'cofre') bankSilver += total;
      else adicionarPrata(total);
      return {
        total,
        linhas: linhas.length,
        destino: body.destino,
        pack: snapshot(),
        recompras: vendasMock.filter(v => !v.feita && v.ate > Date.now())
          .map(v => ({ id: v.id, defId: v.defId, nome: v.nome, qty: v.qty, valor: v.valor, ate: new Date(v.ate).toISOString() }))
      };
    },

    async recomprar(vendaId: string) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const v = vendasMock.find(x => x.id === vendaId);
      if (!v) throw new ApiError('Esse item não está na sua mochila.', 404);
      if (v.feita || v.ate <= Date.now()) throw new ApiError('O prazo da recompra acabou.', 409, 'venda.expirou');
      const coin = bag.find(i => i.defId === 'silver' && !i.equippedSlot);
      if (bankSilver + (coin?.qty ?? 0) < v.valor) throw new ApiError('Você não tem prata para recomprar.', 409, 'venda.semPrata');
      if (weightOf(bag) + v.qty * v.peso > weightMax) throw new ApiError('A mochila não aguenta esse peso.', 409, 'venda.semPeso');
      const doCofre = Math.min(bankSilver, v.valor);
      bankSilver -= doCofre;
      const daMochila = v.valor - doCofre;
      if (daMochila > 0 && coin) {
        coin.qty -= daMochila;
        coin.weight = coin.qty * 0.02;
        if (coin.qty <= 0) bag.splice(bag.indexOf(coin), 1);
      }
      if (MOCK_ITEM_DEFS.get(v.defId)?.stackable)
        empilharMock(bag, v.defId, v.qty, v.peso, q => ({ id: `i${nextItem++}`, defId: v.defId, name: v.nome, qty: q, dur: v.dur, durMax: v.durMax, weight: q * v.peso, equippedSlot: null }));
      else
        bag.push({ id: `i${nextItem++}`, defId: v.defId, name: v.nome, qty: v.qty, dur: v.dur, durMax: v.durMax, weight: v.qty * v.peso, equippedSlot: null });
      v.feita = true;
      return {
        defId: v.defId,
        qty: v.qty,
        valor: v.valor,
        pack: snapshot(),
        recompras: vendasMock.filter(x => !x.feita && x.ate > Date.now())
          .map(x => ({ id: x.id, defId: x.defId, nome: x.nome, qty: x.qty, valor: x.valor, ate: new Date(x.ate).toISOString() }))
      };
    },

    async recomprarVarias(vendaIds: readonly string[]) {
      // O mock recompra uma a uma; o servidor faz tudo ou nada numa transação.
      let ultimo: RecompraResultado | null = null;
      let qty = 0;
      let valor = 0;
      for (const id of vendaIds) {
        ultimo = await this.recomprar(id);
        qty += ultimo.qty;
        valor += ultimo.valor;
      }
      if (!ultimo) throw new ApiError('Pedido de venda inválido.', 400);
      return { ...ultimo, qty, valor };
    },

    async travarVenda(defId: string, travado: boolean) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      travasMock.set(defId, travado);
      return { defId, travado };
    },

    async npcShop(npcId: string): Promise<NpcShop> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!npcId) throw new ApiError('Este vendedor não está aqui.', 404);
      return mockNpcShop(npcId);
    },

    async buyNpc(npcId: string, itens: ReadonlyArray<{ defId: string; qty: number }>): Promise<Pack> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!npcId) throw new ApiError('Este vendedor não está aqui.', 404);
      const shop = mockNpcShop(npcId);
      const pedido: { oferta: NpcShop['itens'][number]; amount: number }[] = [];
      let total = 0;
      let addPeso = 0;
      for (const linha of itens) {
        const oferta = shop.itens.find(i => i.defId === linha.defId);
        if (!oferta) throw new ApiError('Ele não vende isso.', 400);
        const amount = linha.qty;
        if (amount < 1 || amount > 100) throw new ApiError('Informe uma quantidade entre 1 e 100.', 400);
        total += amount * oferta.preco;
        addPeso += amount * oferta.peso;
        pedido.push({ oferta, amount });
      }
      if (!pedido.length) throw new ApiError('Informe uma quantidade entre 1 e 100.', 400);
      const coin = bag.find(i => i.defId === 'silver' && !i.equippedSlot);
      const livre = coin?.qty ?? 0;
      if (livre + bankSilver < total) throw new ApiError('Você não tem prata suficiente.', 409, 'loja.semPrata');
      const daMochila = Math.min(livre, total);
      const doBanco = total - daMochila;
      if (weightOf(bag) - daMochila * 0.02 + addPeso > weightMax)
        throw new ApiError('A mochila não aguenta esse peso.', 409, 'loja.semPeso');
      if (daMochila > 0 && coin) {
        if (coin.qty === daMochila) bag.splice(bag.indexOf(coin), 1);
        else {
          coin.qty -= daMochila;
          coin.weight = coin.qty * 0.02;
        }
      }
      bankSilver -= doBanco;
      for (const { oferta, amount } of pedido) {
        empilharMock(bag, oferta.defId, amount, oferta.peso, q => ({
          id: `i${nextItem++}`, defId: oferta.defId, name: oferta.nome, qty: q, dur: null, durMax: null, weight: q * oferta.peso, equippedSlot: null
        }));
      }
      return snapshot();
    },

    async cidadeLoja(): Promise<CidadeLoja> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return { mapa: 'minoc', forca: 18, itens: MOCK_CIDADE_LOJA };
    },

    async comprarCidade(itens: ReadonlyArray<{ npcId: string; defId: string; qty: number }>): Promise<Pack> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const pedido: { oferta: CidadeItem; amount: number }[] = [];
      let total = 0;
      let addPeso = 0;
      for (const linha of itens) {
        const oferta = MOCK_CIDADE_LOJA.find(i => i.npcId === linha.npcId && i.defId === linha.defId);
        if (!oferta) throw new ApiError('Ele não vende isso.', 400);
        if (linha.qty < 1 || linha.qty > 100) throw new ApiError('Informe uma quantidade entre 1 e 100.', 400);
        total += linha.qty * oferta.preco;
        addPeso += linha.qty * oferta.peso;
        pedido.push({ oferta, amount: linha.qty });
      }
      if (!pedido.length) throw new ApiError('Informe uma quantidade entre 1 e 100.', 400);
      const coin = bag.find(i => i.defId === 'silver' && !i.equippedSlot);
      const livre = coin?.qty ?? 0;
      if (livre + bankSilver < total) throw new ApiError('Você não tem prata suficiente.', 409, 'loja.semPrata');
      const daMochila = Math.min(livre, total);
      if (weightOf(bag) - daMochila * 0.02 + addPeso > weightMax)
        throw new ApiError('A mochila não aguenta esse peso.', 409, 'loja.semPeso');
      if (daMochila > 0 && coin) {
        if (coin.qty === daMochila) bag.splice(bag.indexOf(coin), 1);
        else { coin.qty -= daMochila; coin.weight = coin.qty * 0.02; }
      }
      bankSilver -= total - daMochila;
      for (const { oferta, amount } of pedido) {
        empilharMock(bag, oferta.defId, amount, oferta.peso, q => ({
          id: `i${nextItem++}`, defId: oferta.defId, name: oferta.nome, qty: q, dur: null, durMax: null, weight: q * oferta.peso, equippedSlot: null
        }));
      }
      return snapshot();
    },

    async getBanco(npcId: string): Promise<Banco> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!npcId) throw new ApiError('Este banqueiro não está aqui.', 404);
      return snapshotBanco();
    },

    async guardarBanco(npcId: string, body: { itemId: string; qty?: number }): Promise<BancoMove> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!npcId) throw new ApiError('Este banqueiro não está aqui.', 404);
      const item = bag.find(i => i.id === body.itemId && !i.equippedSlot);
      if (!item) throw new ApiError('Esse item não está na sua mochila.', 404);
      const amount = body.qty ?? item.qty;
      if (amount < 1 || amount > item.qty) throw new ApiError('Informe uma quantidade válida.', 400);
      if (item.defId === 'silver' || item.defId === 'gold') {
        if (item.defId === 'silver') bankSilver += amount;
        else bankGold += amount;
      } else {
        // Teto de 999 por pilha: completa as do cofre e abre vaga para o resto.
        const empilha = !!MOCK_ITEM_DEFS.get(item.defId)?.stackable;
        const pilhas = empilha ? vault.filter(v => v.defId === item.defId && v.qty < PILHA_MAX) : [];
        let resto = amount;
        const cabeNasPilhas = pilhas.reduce((a, v) => a + (PILHA_MAX - v.qty), 0);
        const novas = empilha ? Math.ceil(Math.max(0, resto - cabeNasPilhas) / PILHA_MAX) : 1;
        if (vault.length + novas > 50) throw new ApiError('O cofre está cheio.', 409, 'banco.cheio');
        if (pesoDoVault() + amount * (MOCK_ITEM_DEFS.get(item.defId)?.weight ?? 0) > 800)
          throw new ApiError('O cofre não aguenta esse peso.', 409, 'banco.cofrePesado');
        for (const v of pilhas.sort((a, b) => b.qty - a.qty)) {
          const c = Math.min(PILHA_MAX - v.qty, resto);
          v.qty += c;
          resto -= c;
        }
        while (resto > 0) {
          const q = empilha ? Math.min(PILHA_MAX, resto) : resto;
          vault.push({
            id: `b${nextBank++}`,
            defId: item.defId,
            nome: item.name,
            qty: q,
            dur: item.dur,
            durMax: item.durMax,
            material: item.material ?? null
          });
          resto -= q;
        }
      }
      if (amount === item.qty) bag.splice(bag.indexOf(item), 1);
      else {
        item.qty -= amount;
        const w = MOCK_ITEM_DEFS.get(item.defId)?.weight ?? 0;
        item.weight = item.qty * w;
      }
      return { banco: snapshotBanco(), pack: snapshot() };
    },

    async sacarBanco(npcId: string, body: { bankItemId: string; qty?: number }): Promise<BancoMove> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!npcId) throw new ApiError('Este banqueiro não está aqui.', 404);
      const row = vault.find(v => v.id === body.bankItemId);
      if (!row) throw new ApiError('Esse item não está no cofre.', 404);
      const amount = body.qty ?? row.qty;
      if (amount < 1 || amount > row.qty) throw new ApiError('Informe uma quantidade válida.', 400);
      receberNoPack(row.defId, amount, row.dur, row.nome);
      if (amount === row.qty) vault.splice(vault.indexOf(row), 1);
      else row.qty -= amount;
      return { banco: snapshotBanco(), pack: snapshot() };
    },

    async depositarMoeda(_npcId: string, body: { moeda: string; qtd?: number; tudo?: boolean }): Promise<BancoMove> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (body.moeda !== 'silver' && body.moeda !== 'gold') throw new ApiError('Só prata ou ouro.', 400);
      const item = bag.find(i => i.defId === body.moeda && !i.equippedSlot);
      if (!item) throw new ApiError('Você não tem essa moeda na mochila.', 409);
      const amount = body.tudo ? item.qty : body.qtd ?? 0;
      if (amount < 1 || amount > item.qty) throw new ApiError('Informe uma quantidade válida.', 400);
      if (body.moeda === 'silver') bankSilver += amount;
      else bankGold += amount;
      if (amount === item.qty) bag.splice(bag.indexOf(item), 1);
      else {
        item.qty -= amount;
        item.weight = item.qty * 0.02;
      }
      return { banco: snapshotBanco(), pack: snapshot() };
    },

    async sacarMoeda(_npcId: string, body: { moeda: string; qtd: number }): Promise<BancoMove> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (body.moeda !== 'silver' && body.moeda !== 'gold') throw new ApiError('Só prata ou ouro.', 400);
      const saldo = body.moeda === 'silver' ? bankSilver : bankGold;
      if (body.qtd < 1 || body.qtd > saldo) throw new ApiError('O cofre não tem saldo bastante.', 409, 'banco.semSaldo');
      receberNoPack(body.moeda, body.qtd, null, body.moeda === 'silver' ? 'Prata' : 'Ouro');
      if (body.moeda === 'silver') bankSilver -= body.qtd;
      else bankGold -= body.qtd;
      return { banco: snapshotBanco(), pack: snapshot() };
    },

    async listarModelos(npcId: string): Promise<HouseCatalogo> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!npcId) throw new ApiError(t('casa.naoVende'), 404, 'casa.naoVende');
      return { npcId, lugar: 'Vilarejo de Minoc', modelos: catalogoMock(), minha: casaMock };
    },

    async comprarCasa(npcId: string, modeloId: string): Promise<HouseBuy> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const modelo = MODELOS_MOCK.find(m => m.id === modeloId);
      if (!npcId || !modelo) throw new ApiError(t('casa.naoVende'), 404, 'casa.naoVende');
      if (casaMock) throw new ApiError(t('casa.jaTem'), 409, 'casa.jaTem');
      const numero = PRIMEIRO_LOTE[modelo.classe];
      casaMock = {
        id: `minoc-village-${numero}`,
        numero,
        classe: modelo.classe,
        modelo: modelo.id,
        mapa: 'minoc-village',
        lugar: 'Vilarejo de Minoc',
        soleiraX: SOLEIRA_MOCK[modelo.classe][0],
        soleiraY: SOLEIRA_MOCK[modelo.classe][1],
        maxConvidados: modelo.convidados,
        convidados: []
      };
      return { pack: null, minha: casaMock };
    },

    async casasErguidas(mapaId: string): Promise<readonly CasaErguida[]> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!casaMock?.modelo || mapaId !== casaMock.mapa) return [];
      const { origemNoLote } = await import('../world/casas');
      const o = await origemNoLote(LOTE_MOCK[casaMock.classe], casaMock.modelo);
      return o ? [{
        id: casaMock.id, numero: casaMock.numero, modelo: casaMock.modelo, ...o, papel: 'dono',
        presos: casaPresosMock.map(p => ({ defId: p.defId, x: p.x, y: p.y, z: p.z, giro: p.giro ?? 0, bloqueia: MOBILIA.some(m => m.id === p.defId && !m.assento) })),
        baus: casaBausMock.map(b => ({ x: b.x, y: b.y, z: b.z, giro: b.giro, defId: b.defId })),
        nome: nomeCasaMock, dono: SEED[0].name
      }] : [];
    },

    async placaDaCasa(houseId): Promise<CasaPlaca> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!casaMock || casaMock.id !== houseId) throw new ApiError(t('casa.semCasa'), 404, 'casa.semCasa');
      return { id: casaMock.id, nome: nomeCasaMock, dono: SEED[0].name, modelo: casaMock.modelo ?? '', aberta: !!casaMock.aberta, papel: 'dono' };
    },

    async nomeDaCasa(nome): Promise<MinhaCasa> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!casaMock) throw new ApiError(t('casa.semCasa'), 409, 'casa.semCasa');
      const limpo = nome.trim().replace(/\s+/g, ' ');
      if (limpo && !/^[\p{L}\p{N}][\p{L}\p{N} '\-.,]{1,30}[\p{L}\p{N}.]$/u.test(limpo))
        throw new ApiError('Nome da casa: de 3 a 32 letras, números e espaços.', 400, 'casa.nomeInvalido');
      nomeCasaMock = limpo || null;
      return casaMock;
    },

    async devolverCasa(): Promise<void> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!casaMock) throw new ApiError(t('casa.semCasa'), 409, 'casa.semCasa');
      if (casaPresosMock.length || casaBausMock.length)
        throw new ApiError('Esvazie a casa antes de devolver: solte os itens presos e recolha os baús.', 409, 'casa.naoVazia');
      casaMock = null;
    },

    async casaItens(_houseId): Promise<CasaItens> {
      casaDoMock();
      return casaItensMock();
    },

    async prenderNaCasa(_houseId, body): Promise<CasaItensMove> {
      const m = casaDoMock();
      const item = bag.find(i => i.id === body.itemId && !i.equippedSlot);
      if (!item) throw new ApiError('Esse item não está na sua mochila.', 404);
      const qty = body.qty ?? item.qty;
      if (qty < 1 || qty > item.qty) throw new ApiError('Informe uma quantidade válida.', 400);
      // Baú comprado (techspec-casa-interface-e-baus §01.4): sai da mochila e vira baú, sem contar nos presos.
      if (MOBILIA.find(x => x.id === item.defId)?.bau) {
        novoBauMock(item.defId, body);
        tirarDoBagMock(item, 1);
        return { casa: casaItensMock(), pack: snapshot() };
      }
      const oficio = oficioDe(item.defId);
      if (oficio) {
        if (casaPresosMock.some(p => p.defId === item.defId)) throw new ApiError('Esta casa já tem essa ferramenta de ofício.', 409, 'casa.oficioRepetido');
        if (casaPresosMock.filter(p => oficioDe(p.defId)).length >= VAGAS_OFICIO_MOCK(m.id))
          throw new ApiError('A casa não tem mais vaga de ferramenta de ofício.', 409, 'casa.semVagaOficio');
      } else if (casaPresosMock.filter(p => !oficioDe(p.defId)).length >= m.presos)
        throw new ApiError('A casa não aceita mais itens presos.', 409, 'casa.cheiaPresos');
      pontoLivreMock(body, alturaDe(item.defId));
      casaPresosMock.push({
        id: `hp${nextCasaItem++}`, defId: item.defId, nome: item.name, qty: oficio || alturaDe(item.defId) > 1 ? 1 : qty, x: body.x, y: body.y, z: body.z,
        giro: Math.max(0, Math.min(girosDe(item.defId) - 1, body.giro ?? 0)), altura: alturaDe(item.defId)
      });
      tirarDoBagMock(item, qty);
      return { casa: casaItensMock(), pack: snapshot() };
    },

    async moverNaCasa(_houseId, id, body): Promise<CasaItensMove> {
      casaDoMock();
      const p = casaPresosMock.find(x => x.id === id);
      if (!p) throw new ApiError('Esse item não está na casa.', 404, 'casa.naoEsta');
      pontoLivreMock(body, alturaDe(p.defId), p.id);
      casaPresosMock = casaPresosMock.map(x => (x === p
        ? { ...x, x: body.x, y: body.y, z: body.z, giro: Math.max(0, Math.min(girosDe(p.defId) - 1, body.giro)) } : x));
      return { casa: casaItensMock(), pack: snapshot() };
    },

    async oficiosRegras(): Promise<OficiosRegras> {
      return { ferramentas: FERRAMENTAS_OFICIO.map(f => REGRAS_MOCK(f.oficio)), distancia: 2, papeis: ['dono', 'codono', 'amigo'] };
    },

    async oficioOnde(oficio): Promise<OficioOnde> {
      const f = FERRAMENTAS_OFICIO.find(x => x.oficio === oficio);
      const p = f ? casaPresosMock.find(x => x.defId === f.defId) : undefined;
      const base: OficioOnde = { oficio, perto: true, onde: 'cidade', distancia: null, fx: null, fy: null, fz: null, defId: f?.defId ?? null,
        motivo: null, bonus: null, distanciaMax: 2 };
      if (!p) return base;
      return { ...base, onde: 'casa', distancia: 1, fx: p.x, fy: p.y, fz: p.z, bonus: REGRAS_MOCK(oficio) };
    },

    async ferramentasDaCidade(mapa): Promise<readonly FerramentaDaCidade[]> {
      // A semente do servidor (FerramentasDaCidade.Padrao).
      const semente: Record<string, readonly [string, number, number][]> = {
        minoc: [['ferraria', 25, 77], ['arcos', 19, 40], ['alfaiataria', 67, 76]],
        cove: [['ferraria', 14, 22], ['arcos', 86, 83], ['alfaiataria', 31, 69]]
      };
      return (semente[mapa] ?? []).map(([oficio, x, y]) => ({
        oficio, defId: FERRAMENTAS_OFICIO.find(f => f.oficio === oficio)?.defId ?? '', x, y, giro: 0, bloqueia: true
      }));
    },

    async soltarDaCasa(_houseId, id): Promise<CasaItensMove> {
      casaDoMock();
      const p = casaPresosMock.find(x => x.id === id);
      if (!p) throw new ApiError('Esse item não está na casa.', 404, 'casa.naoEsta');
      casaPresosMock = casaPresosMock.filter(x => x !== p);
      bag.push({ id: `i${nextItem++}`, defId: p.defId, name: p.nome, qty: p.qty, dur: null, durMax: null, weight: 0, equippedSlot: null });
      return { casa: casaItensMock(), pack: snapshot() };
    },

    async porBauNaCasa(_houseId, ponto): Promise<CasaItensMove> {
      novoBauMock(BAU_COMUM_MOCK, ponto);
      return { casa: casaItensMock(), pack: snapshot() };
    },

    async moverBauDaCasa(_houseId, bauId, body): Promise<CasaItensMove> {
      casaDoMock();
      const b = casaBausMock.find(x => x.id === bauId);
      if (!b) throw new ApiError('Esse baú não está aqui.', 404, 'casa.semBau');
      pontoLivreMock(body, alturaDe(b.defId ?? BAU_COMUM_MOCK), b.id);
      casaBausMock = casaBausMock.map(x => (x === b ? { ...x, x: body.x, y: body.y, z: body.z, giro: Math.max(0, Math.min(1, body.giro)) } : x));
      return { casa: casaItensMock(), pack: snapshot() };
    },

    async girarBauDaCasa(_houseId, bauId): Promise<CasaItensMove> {
      casaDoMock();
      casaBausMock = casaBausMock.map(b => (b.id === bauId ? { ...b, giro: b.giro === 0 ? 1 : 0 } : b));
      return { casa: casaItensMock(), pack: snapshot() };
    },

    async recolherBauDaCasa(_houseId, bauId): Promise<CasaItensMove> {
      casaDoMock();
      const b = casaBausMock.find(x => x.id === bauId);
      if (!b) throw new ApiError('Esse baú não está aqui.', 404, 'casa.semBau');
      if (b.itens.length) throw new ApiError('Esvazie o baú antes de recolher.', 409, 'casa.bauNaoVazio');
      casaBausMock = casaBausMock.filter(x => x !== b);
      const def = MOBILIA.find(x => x.id === b.defId);
      if (def && !def.gratis)
        bag.push({ id: `i${nextItem++}`, defId: def.id, name: t(`item.${def.id}`), qty: 1, dur: null, durMax: null, weight: 0, equippedSlot: null });
      return { casa: casaItensMock(), pack: snapshot() };
    },

    async guardarNoBau(_houseId, bauId, body): Promise<CasaItensMove> {
      casaDoMock();
      const b = casaBausMock.find(x => x.id === bauId);
      if (!b) throw new ApiError('Esse baú não está aqui.', 404, 'casa.semBau');
      const item = bag.find(i => i.id === body.itemId && !i.equippedSlot);
      if (!item) throw new ApiError('Esse item não está na sua mochila.', 404);
      if (b.itens.length >= vagasDoBauMock(b.defId ?? BAU_COMUM_MOCK)) throw new ApiError('O baú está cheio.', 409, 'casa.bauCheio');
      const qty = body.qty ?? item.qty;
      const novo = { id: `hi${nextCasaItem++}`, defId: item.defId, nome: item.name, qty, dur: item.dur, durMax: item.durMax, qualidade: 0, feitoPor: null };
      casaBausMock = casaBausMock.map(x => (x === b ? { ...x, itens: [...x.itens, novo] } : x));
      tirarDoBagMock(item, qty);
      return { casa: casaItensMock(), pack: snapshot() };
    },

    async tirarDoBau(_houseId, bauId, body): Promise<CasaItensMove> {
      casaDoMock();
      const b = casaBausMock.find(x => x.id === bauId);
      const i = b?.itens.find(x => x.id === body.id);
      if (!b || !i) throw new ApiError('Esse item não está na casa.', 404, 'casa.naoEsta');
      casaBausMock = casaBausMock.map(x => (x === b ? { ...x, itens: x.itens.filter(y => y !== i) } : x));
      bag.push({ id: `i${nextItem++}`, defId: i.defId, name: i.nome, qty: i.qty, dur: i.dur, durMax: i.durMax, weight: 0, equippedSlot: null });
      return { casa: casaItensMock(), pack: snapshot() };
    },

    async minhaCasa(): Promise<MinhaCasa | null> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return casaMock;
    },

    async configBauDaCasa(_houseId, bauId, body): Promise<CasaItensMove> {
      casaDoMock();
      casaBausMock = casaBausMock.map(b => (b.id === bauId
        ? { ...b, ...(body.perm ? { perm: body.perm } : {}), ...(body.rotulo !== undefined ? { rotulo: body.rotulo.trim() || null } : {}) }
        : b));
      return { casa: casaItensMock(), pack: snapshot() };
    },

    async convidar(nome: string, papel?: string): Promise<MinhaCasa> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!casaMock) throw new ApiError(t('casa.semCasa'), 409, 'casa.semCasa');
      const n = nome.trim();
      if (!n) throw new ApiError(t('casa.semPessoa', { nome }), 404, 'casa.semPessoa');
      const p = papel ?? 'convidado';
      if (!['convidado', 'amigo', 'codono', 'banido'].includes(p)) throw new ApiError('Escolha o papel: convidado, amigo, co-dono ou banido.', 400, 'casa.papel');
      const lista = casaMock.acesso ?? casaMock.convidados.map(c => ({ nome: c, papel: 'convidado' }));
      const atual = lista.find(a => a.nome === n);
      if (atual?.papel === p) throw new ApiError(t('casa.jaConvidado'), 409, 'casa.jaConvidado');
      const outros = lista.filter(a => a.nome !== n);
      if (p !== 'banido' && outros.filter(a => a.papel !== 'banido').length >= casaMock.maxConvidados)
        throw new ApiError(t('casa.cheia'), 409, 'casa.cheia');
      const acesso = atual ? lista.map(a => (a.nome === n ? { nome: n, papel: p } : a)) : [...lista, { nome: n, papel: p }];
      casaMock = { ...casaMock, acesso, convidados: acesso.filter(a => a.papel !== 'banido').map(a => a.nome) };
      return casaMock;
    },

    async desconvidar(nome: string): Promise<MinhaCasa> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!casaMock) throw new ApiError(t('casa.semCasa'), 409, 'casa.semCasa');
      const lista = casaMock.acesso ?? casaMock.convidados.map(c => ({ nome: c, papel: 'convidado' }));
      if (!lista.some(a => a.nome === nome))
        throw new ApiError(t('casa.semPessoa', { nome }), 404, 'casa.semPessoa');
      const acesso = lista.filter(a => a.nome !== nome);
      casaMock = { ...casaMock, acesso, convidados: acesso.filter(a => a.papel !== 'banido').map(a => a.nome) };
      return casaMock;
    },

    async casaAberta(aberta: boolean): Promise<MinhaCasa> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!casaMock) throw new ApiError(t('casa.semCasa'), 409, 'casa.semCasa');
      casaMock = { ...casaMock, aberta };
      return casaMock;
    },

    async buyItem(defId: string, qty?: number, _characterId?: string): Promise<PackItem> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (defId.startsWith('gmkit:')) {
        const pecas = pecasDoKitGm(defId);
        if (pecas.length === 0) throw new ApiError('Este item não existe.', 400);
        const amount = qty ?? 1;
        if (amount !== 1) throw new ApiError('Esta peça não empilha.', 400);
        const add = pecas.reduce((s, p) => s + p.weight, 0);
        if (weightOf(bag) + add > weightMax) throw new ApiError('A mochila não aguenta esse peso.', 409);
        let last: PackItem | null = null;
        for (const p of pecas) {
          const row: MutablePack = {
            id: `i${nextItem++}`, defId: p.defId, name: p.name, qty: 1,
            dur: 60, durMax: 60, weight: p.weight, equippedSlot: null
          };
          bag.push(row);
          last = row;
        }
        return last!;
      }
      const def = MOCK_ITEM_DEFS.get(defId);
      if (!def) throw new ApiError('Este item não existe.', 400);
      const amount = qty ?? 1;
      if (amount < 1 || amount > 100) throw new ApiError('Informe uma quantidade entre 1 e 100.', 400);
      if (!def.stackable && amount !== 1) throw new ApiError('Esta peça não empilha.', 400);
      const add = amount * def.weight;
      if (weightOf(bag) + add > weightMax) {
        throw new ApiError('A mochila não aguenta esse peso.', 409);
      }
      if (def.stackable) {
        const linha = empilharMock(bag, def.id, amount, def.weight, q => ({
          id: `i${nextItem++}`, defId: def.id, name: def.name, qty: q, dur: null, durMax: null, weight: q * def.weight, equippedSlot: null, material: def.material ?? null
        }));
        return { ...linha };
      }
      const row: MutablePack = {
        id: `i${nextItem++}`,
        defId: def.id,
        name: def.name,
        qty: amount,
        dur: def.stackable ? null : 60,
        durMax: def.stackable ? null : 60,
        weight: add,
        equippedSlot: null,
        material: def.material ?? null
      };
      bag.push(row);
      return { ...row };
    },

    async sellItem(itemId: string, qty?: number): Promise<void> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const idx = bag.findIndex(i => i.id === itemId);
      if (idx < 0) throw new ApiError('Esse item não está na sua mochila.', 404);
      const item = bag[idx];
      if (item.equippedSlot) throw new ApiError('Tire a peça do corpo para vender.', 409);
      const def = MOCK_ITEM_DEFS.get(item.defId);
      const amount = qty ?? 1;
      if (amount < 1 || amount > 100) throw new ApiError('Informe uma quantidade entre 1 e 100.', 400);
      if (def && !def.stackable && amount !== 1) throw new ApiError('Esta peça não empilha.', 400);
      if (amount > item.qty) throw new ApiError('Informe uma quantidade entre 1 e 100.', 400);
      if (amount === item.qty) bag.splice(idx, 1);
      else {
        item.qty -= amount;
        item.weight = item.qty * (def?.weight ?? item.weight / (item.qty + amount));
      }
    },

    async mercadoCatalogo() {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return mercado.catalogo();
    },
    async mercadoItem(defId, query) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return mercado.item(defId, query);
    },
    async mercadoOferta(lotId) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return mercado.oferta(lotId);
    },
    async mercadoMeus() {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return mercado.meus();
    },
    async mercadoAnunciar(body) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const idx = bag.findIndex(i => i.id === body.itemId);
      if (idx < 0) throw new ApiError('Esse item não está na sua mochila.', 404);
      const item = bag[idx];
      if (item.equippedSlot) throw new ApiError('Tire a peça do corpo para vender.', 409);
      const qty = Math.min(item.qty, Math.max(1, body.qty ?? item.qty));
      const ref = body.compraJa != null ? Math.max(body.lanceMinimo, body.compraJa) : body.lanceMinimo;
      const taxa = Math.max(1, Math.round(ref * (body.horas === 48 ? 0.12 : body.horas === 24 ? 0.11 : 0.10)));
      if (taxa > bankSilver + snapshot().silver) throw new ApiError('Seu saldo não cobre a taxa.', 409);
      pagarPrata(taxa);
      const r = mercado.anunciar(item.defId, qty, item.dur ?? null, item.durMax ?? null, body.lanceMinimo, body.compraJa ?? null, body.horas);
      if (qty >= item.qty) bag.splice(idx, 1);
      else item.qty -= qty;
      return r;
    },
    async mercadoLance(lotId, teto) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return mercado.lance(lotId, teto);
    },
    async mercadoComprarJa(lotId) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return mercado.comprarJa(lotId);
    },
    async mercadoCancelar(lotId) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const l = mercado.cancelar(lotId);
      const def = MOCK_ITEM_DEFS.get(l.defId);
      bag.push({ id: `m${Date.now()}`, defId: l.defId, name: def?.name ?? l.defId, qty: l.qty, dur: l.dur, durMax: l.durMax, weight: (def?.weight ?? 0) * l.qty, equippedSlot: null, material: null });
    },
    async mercadoRetirar(id) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      mercado.retirar(id);
    },

    async equipItem(itemId: string): Promise<Pack> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const item = bag.find(i => i.id === itemId);
      if (!item) throw new ApiError('Esse item não está na sua mochila.', 404);
      const def = MOCK_ITEM_DEFS.get(item.defId);
      const worn = def ? wornSlot(def.equipSlot) : null;
      if (!def || !worn || def.stackable) throw new ApiError('Esta peça não se veste.', 400);
      if (mockStrReq(def.id) > strength) throw new ApiError('Você não tem força para isso.', 409);
      if (def.equipSlot === 'weapon' && mockHands(def.id) === 2) {
        const off = bag.find(i => i.equippedSlot === 'offHand');
        if (off) off.equippedSlot = null;
      }
      if (def.equipSlot === 'shield') {
        const main = bag.find(i => i.equippedSlot === 'mainHand');
        if (main && mockHands(main.defId) === 2) main.equippedSlot = null;
      }
      const occupant = bag.find(i => i.equippedSlot === worn && i.id !== item.id);
      if (occupant) occupant.equippedSlot = null;
      item.equippedSlot = worn;
      return snapshot();
    },

    async unequipItem(itemId: string): Promise<Pack> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const item = bag.find(i => i.id === itemId);
      if (!item) throw new ApiError('Esse item não está na sua mochila.', 404);
      item.equippedSlot = null;
      return snapshot();
    },

    async getTraje(): Promise<TrajeDto> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return trajeDto();
    },

    async salvarTraje(doc: TrajeDoc): Promise<TrajeDto> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      for (const [slot, e] of Object.entries(doc.pecas)) {
        const skin = e.peca ? MOCK_SKINS.find(s => s.id === e.peca) : null;
        if (skin) {
          if (skin.slot !== slot) throw new ApiError(t('traje.erroPecaInvalida'), 400, 'traje.erroPecaInvalida');
          if (skin.soMulher && !trajeFem) throw new ApiError(t('traje.erroSoMulher'), 400, 'traje.erroSoMulher');
          if (!skinsMock.has(skin.id)) throw new ApiError(t('traje.erroSemASkin'), 409, 'traje.erroSemASkin');
          if (!skin.tingivel) continue;
          const corDaSkin = MOCK_TRAJE_CORES.find(x => x.id === e.cor);
          if (!corDaSkin) throw new ApiError(t('traje.erroCorInvalida'), 400, 'traje.erroCorInvalida');
          if (!corDaSkin.livre && !tintasGuardadas.has(corDaSkin.id)) throw new ApiError(t('traje.erroSemATinta'), 409, 'traje.erroSemATinta');
          continue;
        }
        if (e.peca && MATIZ_DA_CAPA[e.peca] != null) {
          if (slot !== 'capa') throw new ApiError(t('traje.erroPecaInvalida'), 400, 'traje.erroPecaInvalida');
          if (!chefeMock.capas.has(e.peca)) throw new ApiError(t('traje.erroSemAExclusiva'), 409, 'traje.erroSemAExclusiva');
          continue;
        }
        const peca = e.peca ? MOCK_TRAJE_PECAS.find(x => x.id === e.peca) : null;
        if (e.peca && (!peca || peca.slot !== slot)) throw new ApiError(t('traje.erroPecaInvalida'), 400, 'traje.erroPecaInvalida');
        if (peca?.soMulher && !trajeFem) throw new ApiError(t('traje.erroSoMulher'), 400, 'traje.erroSoMulher');
        const cor = MOCK_TRAJE_CORES.find(x => x.id === e.cor);
        if (!cor) throw new ApiError(t('traje.erroCorInvalida'), 400, 'traje.erroCorInvalida');
        if (!cor.livre && !tintasGuardadas.has(cor.id)) throw new ApiError(t('traje.erroSemATinta'), 409, 'traje.erroSemATinta');
      }
      // A skin não tem tinta: a cor gravada é a Natural, como no servidor.
      trajeMock = {
        ...doc,
        pecas: Object.fromEntries(Object.entries(doc.pecas).map(([k, e]) => [k, e.peca && MOCK_SKINS.some(s => s.id === e.peca && !s.tingivel) ? { ...e, cor: 'natural' } : e]))
      };
      trajeSalvo = true;
      return trajeDto();
    },

    async guardarTinta(itemId: string): Promise<TrajeDto> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const item = bag.find(i => i.id === itemId && !i.equippedSlot);
      if (!item) throw new ApiError('Esse item não está na sua mochila.', 404);
      const cor = corDaTinta(item.defId) ?? '';
      if (!MOCK_TRAJE_CORES.some(c => !c.livre && c.id === cor && itemDaTinta(c.id, c.prime) === item.defId)) throw new ApiError(t('traje.erroNaoETinta'), 400, 'traje.erroNaoETinta');
      if (tintasGuardadas.has(cor)) throw new ApiError(t('traje.erroJaGuardada'), 409, 'traje.erroJaGuardada');
      if (item.qty > 1) { item.qty -= 1; item.weight = 0.1 * item.qty; } else bag.splice(bag.indexOf(item), 1);
      tintasGuardadas.add(cor);
      return trajeDto();
    },

    async retirarTinta(cor: string): Promise<TrajeDto> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!tintasGuardadas.has(cor)) throw new ApiError(t('traje.erroNaoGuardada'), 404, 'traje.erroNaoGuardada');
      tintasGuardadas.delete(cor);
      const pecas = Object.fromEntries(Object.entries(trajeMock.pecas).map(([k, e]) => [k, e.cor === cor ? { ...e, cor: 'natural' } : e]));
      trajeMock = { ...trajeMock, pecas };
      const defId = itemDaTinta(cor, !!MOCK_TRAJE_CORES.find(c => c.id === cor)?.prime);
      const pilha = bag.find(i => i.defId === defId && !i.equippedSlot);
      if (pilha) { pilha.qty += 1; pilha.weight = 0.1 * pilha.qty; }
      else bag.push({ id: `i${nextItem++}`, defId, name: MOCK_ITEM_DEFS.get(defId)?.name ?? defId, qty: 1, dur: null, durMax: null, weight: 0.1, equippedSlot: null });
      return trajeDto();
    },

    async guardarSkin(itemId: string): Promise<TrajeDto> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const item = bag.find(i => i.id === itemId && !i.equippedSlot);
      if (!item) throw new ApiError('Esse item não está na sua mochila.', 404);
      const peca = skinDoItem(item.defId) ?? '';
      if (!MOCK_SKINS.some(s => s.id === peca)) throw new ApiError(t('traje.erroNaoESkin'), 400, 'traje.erroNaoESkin');
      if (skinsMock.has(peca)) throw new ApiError(t('traje.erroJaTemASkin'), 409, 'traje.erroJaTemASkin');
      if (item.qty > 1) { item.qty -= 1; item.weight = 0.1 * item.qty; } else bag.splice(bag.indexOf(item), 1);
      skinsMock.add(peca);
      return trajeDto();
    },

    async extrairSkin(peca: string): Promise<TrajeDto> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!skinsMock.has(peca)) throw new ApiError(t('traje.erroSemASkin'), 409, 'traje.erroSemASkin');
      skinsMock.delete(peca);
      const pecas = Object.fromEntries(Object.entries(trajeMock.pecas).map(([k, e]) => [k, e.peca === peca ? { peca: null, cor: 'natural' } : e]));
      trajeMock = { ...trajeMock, pecas };
      const defId = PREFIXO_SKIN + peca;
      const nome = `Skin · ${MOCK_SKINS.find(s => s.id === peca)?.nome ?? peca}`;
      const pilha = bag.find(i => i.defId === defId && !i.equippedSlot);
      if (pilha) { pilha.qty += 1; pilha.weight = 0.1 * pilha.qty; }
      else bag.push({ id: `i${nextItem++}`, defId, name: nome, qty: 1, dur: null, durMax: null, weight: 0.1, equippedSlot: null });
      return trajeDto();
    },

    async marcarSkinVista(peca: string): Promise<void> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      skinsVistas.add(peca);
    },

    async separarItem(itemId: string, qty: number): Promise<SepararResultado> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const item = bag.find(i => i.id === itemId && !i.equippedSlot);
      if (!item) throw new ApiError('Esse item não está na sua mochila.', 404);
      if (qty < 1 || qty >= item.qty) throw new ApiError('Escolha quantas separar: de 1 até uma a menos que a pilha.', 400);
      const un = item.weight / item.qty;
      const novo = { ...item, id: `i${nextItem++}`, qty, weight: un * qty };
      item.qty -= qty;
      item.weight = un * item.qty;
      bag.push(novo);
      return { pack: snapshot(), novoId: novo.id };
    },

    async juntarItem(itemId: string, destinoId: string): Promise<Pack> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const a = bag.find(i => i.id === itemId && !i.equippedSlot);
      const b = bag.find(i => i.id === destinoId && !i.equippedSlot);
      if (!a || !b || a === b || a.defId !== b.defId) throw new ApiError('Só junta com a mesma peça: mesmo item, bênção e marca.', 400);
      b.qty += a.qty;
      b.weight += a.weight;
      bag.splice(bag.indexOf(a), 1);
      return snapshot();
    },

    async dropItem(itemId: string): Promise<Pack> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const idx = bag.findIndex(i => i.id === itemId);
      if (idx < 0) throw new ApiError('Esse item não está na sua mochila.', 404);
      bag.splice(idx, 1);
      return snapshot();
    },

    async getProfile(): Promise<Profile> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return sheet();
    },

    async inspecionar(nome: string): Promise<Inspecao> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      // O mock não tem outros jogadores: devolve um aventureiro de couro com katana.
      return {
        nome, profissao: 'Guerreiro', notoriedade: 'Inocente', guildaTag: 'UO', guildaNome: 'Ordem de Teste',
        vip: false, morto: false, ar: 18,
        conjunto: { familia: 'studded', pecas: 2, pecasExigidas: 5, completo: false },
        itens: [
          { slot: 'mainHand', defId: 'katana', nome: 'Katana' },
          { slot: 'chest', defId: 'studded-chest', nome: 'Peitoral de couro cravejado' },
          { slot: 'legs', defId: 'studded-legs', nome: 'Perneiras de couro cravejado' }
        ]
      };
    },

    async lockSkill(skillId: string, lock: SkillLock): Promise<Profile> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!MOCK_CATALOG.skills.some(s => s.id === skillId)) {
        throw new ApiError('Esta skill não existe.', 400);
      }
      if (lock !== 'raise' && lock !== 'lower' && lock !== 'locked') {
        throw new ApiError('A trava não é válida.', 400);
      }
      skillLocks.set(skillId, lock);
      return sheet();
    },

    async limparProgresso(): Promise<Profile> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      await wait(200);
      marcoMock = new Map(sheet().skills.map(s => [s.id, s.value]));
      return sheet();
    },

    async getHotbar(): Promise<Hotbar> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return paraBarra(barOf(whoId()));
    },

    async setHotbar(slots: Hotbar): Promise<void> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      bars.set(whoId(), paraBarra(slots));
    },

    async getCombatIdle(): Promise<CombatIdleConfig> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const id = whoId();
      const hit = combates.get(id);
      if (hit) return hit;
      const inicial: CombatIdleConfig = {
        ...COMBATE_IDLE_VAZIO,
        versao: COMBATE_IDLE_VERSAO,
        curar: [{ usar: 'item', id: 'healing', abaixoDe: 75 }],
        reservaDeMana: 75
      };
      combates.set(id, inicial);
      return inicial;
    },

    async setCombatIdle(config: CombatIdleConfig): Promise<void> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      // O mock limpa como o servidor limpa: senão a tela passa no mock e falha
      // no jogo, que é o pior lugar para descobrir.
      combates.set(whoId(), lerCombatIdle(config));
    },

    async getCacadaEspalhada(): Promise<boolean> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return espalhadas.has(whoId());
    },

    async setCacadaEspalhada(ligado: boolean): Promise<void> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (ligado) espalhadas.add(whoId()); else espalhadas.delete(whoId());
    },

    async eventoAtual() {
      // ?mockEvento=aberto | inscrito | luta mostra o quadro com uma sessão rolando (techspec-eventos §08).
      const modo = new URLSearchParams(location.search).get('mockEvento');
      const vivo = modo === 'aberto' || modo === 'inscrito' || modo === 'luta';
      return {
        estado: modo === 'luta' ? 2 : vivo ? 1 : 0, inscrito: modo === 'inscrito', moeda: 'silver', taxa: 50000, bolo: vivo ? 350000 : 0,
        inscritos: vivo ? 7 : 0, fechaEmMs: vivo ? Date.now() + 222_000 : 0, fimEmMs: modo === 'luta' ? Date.now() + 420_000 : 0,
        vivos: modo === 'luta' ? 4 : 0, portaAberta: false,
        modo: 'trajeDaCasa', kit: [], trava: vivo ? null : 'evento.semSessao',
        inscricaoSegundos: 300, partidaSegundos: 900, daemonSegundos: 180, pares: 0,
        agendado: true, porSala: 6, minimo: 4, podio: [55, 25, 10], queimaPct: 10
      };
    },
    async eventoAgenda() {
      const hoje = new Date();
      const as = (h: number, dia = 0) => new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + dia, h, 0, 0).getTime();
      const proximos = [...[as(15), as(21), as(15, 1), as(21, 1), as(15, 2)]
        .filter(ms => ms > Date.now()).slice(0, 4)
        .map(ms => ({ id: new Date(ms).getHours() === 15 ? 'tarde' : 'noite', hora: new Date(ms).getHours() === 15 ? '15:00' : '21:00', emMs: ms, tipo: 'ultimate-battle' })),
      ...chefeMock.proximos()].sort((a, b) => a.emMs - b.emMs).slice(0, 6);
      return {
        proximos,
        hoje: [
          { id: 'chefe-tarde', hora: '13:00', emMs: as(13), tipo: 'chefe-mundo' },
          { id: 'tarde', hora: '15:00', emMs: as(15), tipo: 'ultimate-battle' },
          { id: 'chefe-noite', hora: '19:00', emMs: as(19), tipo: 'chefe-mundo' },
          { id: 'noite', hora: '21:00', emMs: as(21), tipo: 'ultimate-battle' }
        ],
        diaInicioMs: as(0), diaFimMs: as(0, 1),
        inscricaoSegundos: 300, partidaSegundos: 900, daemonSegundos: 180, avisoSegundos: 900,
        kit: [
          { defId: 'plate-chest', qtd: 1, equipado: true }, { defId: 'plate-arms', qtd: 1, equipado: true },
          { defId: 'plate-gloves', qtd: 1, equipado: true }, { defId: 'plate-legs', qtd: 1, equipado: true },
          { defId: 'plate-helm', qtd: 1, equipado: true }, { defId: 'katana', qtd: 1, equipado: true },
          { defId: 'bandage', qtd: 20, equipado: false }
        ],
        inscricao: 50000, moeda: 'silver', porSala: 6, minimo: 4, podio: [55, 25, 10], queimaPct: 10,
        sorteiosPorDia: 2, sorteiosHoje: 0, garantiaContador: 3,
        tabelas: [{
          id: 'ub-participacao', nome: 'Participação', garantiaEventos: 10, garantiaRaridade: 'raro',
          raridades: [
            { id: 'comum', chance: 62, itens: [{ def: 'bandage', qtdMin: 20, qtdMax: 20, chance: 31 }, { def: 'silver', qtdMin: 2000, qtdMax: 5000, chance: 31 }] },
            { id: 'raro', chance: 38, itens: [{ def: 'golden-ingot', qtdMin: 5, qtdMax: 5, chance: 38 }] }
          ]
        }],
        pendentes: [],
        versao: 1
      };
    },
    async eventoChefe() { return chefeMock.ler(); },
    async eventoChefeIniciar() { /* mock: o chefe é do servidor */ },
    async eventoChefeEncerrar() { /* mock */ },
    async eventoPentagrama() { return pentaMock(); },
    async eventoPentagramaIniciar() { /* mock: o evento é do servidor */ },
    async eventoPentagramaEncerrar() { /* mock */ },
    async eventoAltarTrocar(oferta: string, versao: number) { return chefeMock.trocar(oferta, versao); },
    async eventoInscrever() { throw new ApiError('Não há evento aberto.', 409); },
    async eventoDesistir() { throw new ApiError('Não há evento aberto.', 409); },
    async eventoAbrir() { /* mock: evento é do servidor */ },
    async eventoCancelar() { /* mock */ },

    async listGmOnline(q, take, sala): Promise<GmOnlinePagina> {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const me = chars[0];
      const eu = me ? gmRow(me, true) : null;
      let filtrados = eu ? [eu, ...falsosGm] : [...falsosGm];
      if (sala) filtrados = filtrados.filter(r => r.you || (eu && r.city === eu.city && (r.canal ?? 0) === (eu.canal ?? 0)));
      const nq = q?.trim().toLowerCase();
      if (nq) {
        filtrados = filtrados
          .filter(r => r.name.toLowerCase().includes(nq))
          .sort((a, b) => Number(!a.you) - Number(!b.you) || Number(!a.name.toLowerCase().startsWith(nq)) - Number(!b.name.toLowerCase().startsWith(nq)));
      }
      const n = Math.min(Math.max(take ?? 10, 1), 25);
      return { itens: filtrados.slice(0, n), total: filtrados.length, mostrando: Math.min(n, filtrados.length), ocultoHabilitado: true };
    },

    async gmOculto(ligado) {
      mockOculto = ligado;
      return { ligado };
    },

    async gmHora(hora, minuto) {
      if (!Number.isInteger(hora) || !Number.isInteger(minuto) || hora < 0 || hora > 23 || minuto < 0 || minuto > 59)
        throw new ApiError(t('gm.horaInvalida'), 400);
      const m = hora * 60 + minuto;
      sincronizarHora(m, MS_POR_MINUTO);
      return { minuto: m, msPorMinuto: MS_POR_MINUTO };
    },

    async gmSkins() {
      return MOCK_SETS_DE_SKIN.map(skinSetMock);
    },

    async gmPegarSkin(set) {
      const s = MOCK_SETS_DE_SKIN.find(x => x.id === set);
      if (!s) throw new ApiError(t('gm.skins.setInvalido'), 400);
      const novas = s.pecas.filter(p => !skinsMock.has(p));
      for (const p of novas) skinsMock.add(p);
      return { set: s.id, novas, atual: skinSetMock(s) };
    },

    async gmIr(characterId) {
      const falso = falsosGm.find(f => f.id === characterId);
      return { cidade: falso?.city ?? 'Britain', canal: falso?.canal ?? 0, x: 38, y: 40 };
    },

    async gmKill(characterId): Promise<GmOnline> {
      const falso = gmFalso(characterId, { dead: true });
      if (falso) return falso;
      const row = chars.find(c => c.id === characterId);
      if (!row) throw new ApiError('Este personagem não está online neste shard.', 404);
      const next = { ...row, dead: true };
      const i = chars.findIndex(c => c.id === characterId);
      chars[i] = next;
      return gmRow(next, true);
    },

    async gmRevive(characterId): Promise<GmOnline> {
      const falso = gmFalso(characterId, { dead: false });
      if (falso) return falso;
      const row = chars.find(c => c.id === characterId);
      if (!row) throw new ApiError('Este personagem não está online neste shard.', 404);
      const next = { ...row, dead: false };
      const i = chars.findIndex(c => c.id === characterId);
      chars[i] = next;
      return gmRow(next, true);
    },

    async getGuildMe() { return house; },
    async getGuildRules() {
      return {
        const: {
          nameMin: 2, nameMax: 20, tagMax: 4, titleMax: 20, warGold: 50_000, allianceCap: 5,
          inviteMinutes: 10, cooldownHours: 72, warKillsMax: 1000, warHoursMax: 168
        },
        perms: {
          CanInvite: ['lider', 'emissario'],
          CanRank: ['lider', 'emissario'],
          CanMotd: ['lider', 'comandante'],
          CanKickRecruit: ['lider', 'comandante', 'emissario'],
          CanKickMember: ['lider', 'comandante'],
          CanKickAny: ['lider'],
          CanVault: ['lider'],
          CanAlliance: ['lider'],
          CanWar: ['lider'],
          CanVote: ['lider', 'comandante', 'emissario', 'membro'],
          CanLead: ['lider']
        }
      } as const;
    },
    async listGuilds() { return directory; },
    async createGuild(name, tag) {
      if (house) throw new ApiError('Você já está numa guilda.', 409);
      const me = chars.find(c => c.shardId === activeShard);
      house = mockHouse(name, tag.toUpperCase(), me?.name ?? 'Você', 'lider');
      directory = [{ id: house.id, name: house.name, tag: house.tag, members: 1, leader: me?.name ?? 'Você', allianceTag: '' }];
      return house;
    },
    async leaveGuild() { house = null; },
    async inviteGuild() { /* mock: sem hub */ },
    async acceptGuild() {
      if (!house) throw new ApiError('Não há um convite pendente.', 409);
      return house;
    },
    async declineGuild() {},
    async applyGuild(id) { applied.add(id); },
    async listGuildApplications() { return apps; },
    async acceptGuildApplication() {},
    async refuseGuildApplication() {},
    async setGuildRank() {},
    async passGuildLead() {},
    async kickGuild() {},
    async setGuildTitle() {},
    async setGuildMotd(text) { if (house) house = { ...house, motd: text }; },
    async voteGuild() { return { applied: false, votes: house?.votes ?? [] }; },
    async setGuildTithe(percent) { if (house) house = { ...house, tithe: percent }; },
    async withdrawGuildVault(_amount) {
      if (!house) throw new ApiError('Você não está numa guilda.', 409);
      return { gold: house.gold, entries: [] };
    },
    async getGuildVault() { return { gold: house?.gold ?? 0, entries: [] }; },
    async proposeAlliance() {},
    async acceptAlliance() {},
    async declineAlliance() {},
    async leaveAlliance() {},
    async proposeWar() {},
    async acceptWar() {},
    async declineWar() {},
    async surrenderWar() {},
    async gmCreateGuild(characterId, name, tag) {
      const falso = gmFalso(characterId, { guildTag: tag.toUpperCase(), guildName: name });
      if (falso) return falso;
      const row = chars.find(c => c.id === characterId);
      if (!row) throw new ApiError('Este personagem não está online neste shard.', 404);
      house = mockHouse(name, tag.toUpperCase(), row.name, 'lider');
      return { ...gmRow(row, true), guildTag: tag.toUpperCase(), guildName: name };
    },
    async gmLeaveGuild(characterId) {
      const falso = gmFalso(characterId, { guildTag: undefined, guildName: undefined });
      if (falso) return falso;
      const row = chars.find(c => c.id === characterId);
      if (!row) throw new ApiError('Este personagem não está online neste shard.', 404);
      house = null;
      return gmRow(row, true);
    },
    async gmGuildVault(characterId) { return gmFalso(characterId) ?? gmRow(chars[0], true); },
    async gmBank(characterId) { return gmFalso(characterId) ?? gmRow(chars[0], true); },
    async gmSkills(characterId) { return mockGmSkills(falsosGm.find(f => f.id === characterId)?.name ?? chars[0]?.name ?? 'Você'); },
    async gmSetSkills(_characterId, skills, _cap, atributos) {
      if (atributos) {
        const v = [atributos.for, atributos.des, atributos.int];
        if (v.some(n => !Number.isInteger(n) || n < 1 || n > 100)) throw new ApiError('Cada atributo vai de 1 a 100.', 400);
        if (v[0] + v[1] + v[2] > 300) throw new ApiError('A soma de Força, Destreza e Inteligência passa o teto deste personagem.', 409);
        mockGmAtributos = { ...atributos };
      }
      const sheet = mockGmSkills(chars[0]?.name ?? 'Você');
      const next = sheet.skills.map(s => {
        const hit = skills.find(x => x.id === s.id);
        return hit ? { ...s, value: hit.value } : s;
      });
      mockGmSkillValues = new Map(next.map(s => [s.id, s.value]));
      const total = next.reduce((n, s) => n + s.value, 0);
      if (total > 500) throw new ApiError('O total passa o teto deste personagem.', 409);
      return { ...sheet, skills: next, total };
    },

    async getHunts() {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      return mockBoard();
    },

    async getColeta() {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      // O mock nasce com uma machadinha e uma picareta, para as duas coletas terem como começar.
      if (!coletaDemo) {
        coletaDemo = true;
        if (!bag.some(i => i.defId === 'hatchet'))
          bag.push({ id: `i${nextItem++}`, defId: 'hatchet', name: 'Machadinha', qty: 1, dur: null, durMax: null, weight: 4, equippedSlot: null });
        if (!bag.some(i => i.defId === 'pickaxe'))
          bag.push({ id: `i${nextItem++}`, defId: 'pickaxe', name: 'Picareta', qty: 1, dur: null, durMax: null, weight: 4, equippedSlot: null });
      }
      return estadoColeta();
    },

    async iniciarColeta(recurso) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (recurso !== 'madeira' && recurso !== 'minerio') throw new ApiError('Este recurso ainda não existe.', 400, 'coleta.recurso');
      if (chars.find(c => c.shardId === activeShard)?.dead) throw new ApiError('Fantasmas não coletam.', 400, 'coleta.morto');
      if (mockColeta) throw new ApiError('Você já está coletando.', 409, 'coleta.aberta');
      if (mockOrdem) throw new ApiError('Você está em uma caçada ou ordem.', 409, 'coleta.cacando');
      const [comum, ouro] = FERRAMENTAS[recurso];
      const ferramentas = bag.filter(i => i.defId === comum || i.defId === ouro);
      if (ferramentas.length === 0)
        throw recurso === 'minerio'
          ? new ApiError('Você precisa de uma picareta.', 409, 'coleta.semPicareta')
          : new ApiError('Você precisa de uma machadinha.', 409, 'coleta.semMachadinha');
      // Como no servidor: a melhor ferramenta vai para a mão; a arma e o escudo (duas mãos) saem.
      const melhor = ferramentas.find(i => i.defId === ouro) ?? ferramentas[0];
      if (melhor.equippedSlot !== 'mainHand') {
        for (const i of bag) if (i.equippedSlot === 'mainHand' || i.equippedSlot === 'offHand') i.equippedSlot = null;
        melhor.equippedSlot = 'mainHand';
      }
      const agora = Date.now();
      // A coleta gasta 3/min: com o tanque cheio do mock, 8 h.
      mockColeta = { inicio: agora, terminaEm: agora + 8 * 3600 * 1000, origem: 'Minoc', recurso };
      return estadoColeta();
    },

    async cancelarColeta() {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!mockColeta) throw new ApiError('Você não está coletando.', 409, 'coleta.semColeta');
      mockColeta = null;
      return estadoColeta();
    },

    async estimateHunt(body) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!MOCK_HUNTS.some(h => h.id === body.huntId)) throw new ApiError('Esta caçada não existe neste shard.', 400);
      // HUD V3: a postura saiu do cliente; o servidor usa sempre firme.
      return mockEstimate('firme', body.filtro);
    },

    async protegidaMenu() {
      return { ativa: true, xp: 25, saque: 40, mapasSem: [] };
    },

    async startHunt(body) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      const who = chars.find(c => c.shardId === activeShard);
      if (who?.dead) throw new ApiError('Fantasmas não caçam.', 400);
      if (mockOrdem || mockColeta) throw new ApiError('Você já está em uma ordem.', 409);
      const escolhida = MOCK_HUNTS.find(h => h.id === body.huntId);
      if (!escolhida) throw new ApiError('Esta caçada não existe neste shard.', 400);
      const pode = new Set(escolhida.loot.map(l => l.defId));
      if (body.filtro.some(id => !pode.has(id))) throw new ApiError('Este item não cai nessa caçada.', 400);
      const modo = body.modo ?? 'automatico';
      const aoVer = body.aoVerJogador ?? 'batalhar';
      if (modo !== 'automatico' && modo !== 'manual')
        throw new ApiError('Este modo de caçada não existe.', 400);
      if (aoVer !== 'batalhar' && aoVer !== 'correr')
        throw new ApiError('Escolha entre batalhar e correr.', 400);
      const aoEncher = body.aoEncher ?? 'cofre';
      const raro = body.raroAbaixoDe ?? 10;
      if (aoEncher !== 'cofre' && aoEncher !== 'vender') throw new ApiError('Escolha entre guardar no cofre e vender.', 400);
      if (raro < 0 || raro > 50) throw new ApiError('O limite dos raros vai de 0% a 50%.', 400);
      if (aoEncher === 'vender' && !mockVip) throw new ApiError('Vender o saque na caçada é do VIP.', 403, 'cacada.semVip');
      mockFiltro = [...body.filtro];
      const agora = Date.now();
      mockOrdem = {
        huntId: body.huntId,
        postura: 'firme',
        filtro: [...body.filtro],
        startedAt: new Date(agora).toISOString(),
        terminaEm: new Date(agora + 4 * 3600 * 1000).toISOString(),
        modo,
        aoVerJogador: aoVer,
        area: body.area ?? 'pvp',
        aoEncher,
        raroAbaixoDe: raro
      };
      return mockBoard();
    },

    async regraHunt(body) {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!mockOrdem) throw new ApiError('Você não está em uma caçada.', 409);
      const aoEncher = body.aoEncher ?? mockOrdem.aoEncher ?? 'cofre';
      const raro = body.raroAbaixoDe ?? mockOrdem.raroAbaixoDe ?? 10;
      if (raro < 0 || raro > 50) throw new ApiError('O limite dos raros vai de 0% a 50%.', 400);
      if (aoEncher === 'vender' && !mockVip) throw new ApiError('Vender o saque na caçada é do VIP.', 403, 'cacada.semVip');
      mockOrdem = { ...mockOrdem, aoEncher, raroAbaixoDe: raro };
      return mockBoard();
    },

    async foraVistoHunt() {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      mockForaAberto = false;
      return mockBoard();
    },

    async cancelHunt() {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!mockOrdem) throw new ApiError('Você não está em uma caçada.', 409);
      mockOrdem = null;
      return mockBoard();
    },

    async autoHunt() {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!mockOrdem) throw new ApiError('Você não está em uma caçada.', 409);
      mockOrdem = { ...mockOrdem, modo: 'automatico' };
      return mockBoard();
    },

    async manualHunt() {
      if (!session) throw new ApiError('Sua sessão expirou. Entre de novo.', 401);
      if (!mockOrdem) throw new ApiError('Você não está em uma caçada.', 409);
      mockOrdem = { ...mockOrdem, modo: 'manual' };
      return mockBoard();
    },

    async tabelaCombate() {
      const { TABELA_PADRAO } = await import('../data/combateTabela');
      return { tabela: TABELA_PADRAO, etag: '1-00000000' };
    },

    async esquemaMundo() {
      return { esquemaVersao: 1 };
    },

    async npcsDoMundo() {
      return [];
    },

    async manequinsDoMundo() {
      return [];
    },

    async portaisDoMundo() {
      // Sem servidor não há portais: eles moram em world_portals (techspec-editor-de-mapa §02.3).
      return [];
    },

    async ankhsDoMundo() {
      return [];
    },

    async viagensDoMundo() {
      return [
        // O TextoInicial do ViagemCatalog.cs (techspec-teleportar).
        { id: 'minoc', mapa: 'minoc', x: 75, y: 56, rotulo: 'portal.destino.minoc', tipo: 'cidade', guardas: true },
        { id: 'cove', mapa: 'cove', x: 52, y: 49, rotulo: 'portal.destino.cove', tipo: 'cidade', guardas: false },
        { id: 'serpents-hold', mapa: 'serpents-hold', x: 31, y: 46, rotulo: 'portal.destino.serpents-hold', tipo: 'local', guardas: false },
        { id: 'cemiterio-britain', mapa: 'cemiterio-britain', x: 32, y: 48, rotulo: 'portal.destino.cemiterio', tipo: 'local', guardas: false },
        { id: 'cemiterio-cove', mapa: 'cemiterio-cove', x: 32, y: 48, rotulo: 'portal.destino.cemiterio-cove', tipo: 'local', guardas: false },
        { id: 'orc-fort-yew', mapa: 'orc-fort-yew', x: 32, y: 58, rotulo: 'portal.destino.orc-fort-yew', tipo: 'local', guardas: false },
        { id: 'ice-dungeon', mapa: 'ice-dungeon', x: 119, y: 62, rotulo: 'portal.destino.ice-dungeon', tipo: 'local', guardas: false },
        { id: 'fire-dungeon', mapa: 'fire-dungeon', x: 60, y: 140, rotulo: 'portal.destino.fire-dungeon', tipo: 'local', guardas: false },
        { id: 'destard', mapa: 'destard', x: 71, y: 236, rotulo: 'portal.destino.destard', tipo: 'local', guardas: false }
      ];
    },

    async gmNotoriety(characterId, notoriety): Promise<GmOnline> {
      const falso = gmFalso(characterId, { notoriety });
      if (falso) return falso;
      const row = chars.find(c => c.id === characterId);
      if (!row) throw new ApiError('Este personagem não está online neste shard.', 404);
      if (row.notoriety === notoriety)
        throw new ApiError('Este personagem já está nesse estado.', 409);
      const next = { ...row, notoriety };
      const i = chars.findIndex(c => c.id === characterId);
      chars[i] = next;
      return gmRow(next, true);
    },

    async listMobCatalog(): Promise<readonly MobResumo[]> {
      return MOCK_MOB_DEFS;
    },

    async listGmMobs(): Promise<readonly GmMob[]> {
      return mockMobs.slice();
    },

    async gmSpawnMob(defId, x, y, range): Promise<GmMob> {
      const def = MOCK_MOB_DEFS.find(d => d.defId === defId);
      if (!def) throw new ApiError('Esse inimigo não existe.', 400);
      if (mockMobs.length >= 24) throw new ApiError('A cidade já tem inimigos demais.', 409);
      const r = range ?? 8;
      if (r < 0 || r > 32) throw new ApiError('O alcance precisa ser entre 0 e 32.', 400);
      const mob: GmMob = {
        shortId: ++mockMobSeq,
        defId: def.defId,
        name: def.nome,
        x, y, range: r
      };
      mockMobs.push(mob);
      return mob;
    },

    async gmRemoveMob(shortId): Promise<GmMob> {
      const i = mockMobs.findIndex(m => m.shortId === shortId);
      if (i < 0) throw new ApiError('Esse inimigo já não está no mapa.', 404);
      const [gone] = mockMobs.splice(i, 1);
      return gone;
    },

    async gmTeleport(characterId): Promise<GmOnline> {
      const falso = gmFalso(characterId);
      if (falso) return falso;
      const row = chars.find(c => c.id === characterId);
      if (!row) throw new ApiError('Este personagem não está online neste shard.', 404);
      return gmRow(row, true);
    },

    async gmCity(characterId, cityId): Promise<GmOnline> {
      const row = chars.find(c => c.id === characterId);
      if (!row) throw new ApiError('Este personagem não está online neste shard.', 404);
      const labels: Record<string, string> = {
        britain: 'Britain',
        minoc: 'Minoc',
        cemiterio: 'Cemitério de Britain',
        'cemiterio-britain': 'Cemitério de Britain'
      };
      const label = labels[cityId];
      if (!label) throw new ApiError('Esse mapa ainda não está pronto para teleporte.', 400);
      const falso = gmFalso(characterId);
      if (falso) {
        if (falso.city === label) throw new ApiError('Este personagem já está nessa cidade.', 409);
        return gmFalso(characterId, { city: label })!;
      }
      if (row.homeCity.toLowerCase() === label.toLowerCase())
        throw new ApiError('Este personagem já está nessa cidade.', 409);
      const next = { ...row, homeCity: label };
      chars[chars.findIndex(c => c.id === characterId)] = next;
      return gmRow(next, true);
    }
  };

  function whoId(): string {
    return chars.find(c => c.shardId === activeShard)?.id ?? session?.id ?? 'acc-mock';
  }

  function gmRow(c: CharacterSummary, you: boolean): GmOnline {
    return { id: c.id, name: c.name, city: c.homeCity, dead: c.dead, you, notoriety: c.notoriety, oculto: you && mockOculto, canal: 0 };
  }

  function barOf(id: string): (string | null)[] {
    const hit = bars.get(id);
    if (hit) return hit;
    const empty: (string | null)[] = Array.from({ length: HOTBAR_SIZE }, () => null);
    empty[1] = 'healing';
    empty[2] = 'mana';
    bars.set(id, empty);
    return empty;
  }

  function grupoMock(defId: string): string {
    const base = baseDe(defId);
    for (const g of MOCK_ITEM_CATALOG.groups)
      if (g.items.some(i => i.id === defId || i.id === base)) return g.id;
    return 'misc';
  }

  function adicionarPrata(qty: number) {
    const coin = bag.find(i => i.defId === 'silver' && !i.equippedSlot);
    if (coin) {
      coin.qty += qty;
      coin.weight = coin.qty * 0.02;
    } else {
      bag.push({ id: `i${nextItem++}`, defId: 'silver', name: 'Silver', qty, dur: null, durMax: null, weight: qty * 0.02, equippedSlot: null });
    }
  }

  function ordemColeta(): ColetaOrdem | null {
    if (!mockColeta) return null;
    const minerio = mockColeta.recurso === 'minerio';
    const tent = Math.max(0, Math.floor((Date.now() - mockColeta.inicio) / 4000));
    const toras: Record<string, number> = {};
    let acertos = 0;
    for (let k = 1; k <= tent; k++) {
      // Sorteio fixo por tentativa: o mesmo número a cada leitura.
      const r = ((k * 2654435761) >>> 0) / 4294967296;
      if (r < (minerio ? 0.17 : 0.32)) continue;
      const item = minerio
        ? (r < 0.9 ? 'iron-ingot' : 'dull-copper-ingot')
        : r < 0.88 ? 'log' : r < 0.97 ? 'oak-log' : 'ash-log';
      if (item === 'ash-log' && mockLenhador < 80) { toras.log = (toras.log ?? 0) + 2; acertos++; continue; }
      toras[item] = (toras[item] ?? 0) + 2;
      acertos++;
    }
    return {
      recurso: mockColeta.recurso, startedAt: new Date(mockColeta.inicio).toISOString(),
      terminaEm: new Date(mockColeta.terminaEm).toISOString(), tentativas: tent, acertos, toras,
      parado: null, origem: mockColeta.origem, skillInicio: minerio ? mockMinerador : mockLenhador, naFloresta: true
    };
  }

  /** O lugar de um recurso no mock: a mesma conta das chances do servidor (ColetaMath). */
  function lugarColeta(recurso: 'madeira' | 'minerio'): ColetaLugar {
    const tabela = TABELAS_COLETA[recurso];
    const [comum, ouro] = FERRAMENTAS[recurso];
    // A ferramenta não se gasta; a de ouro soma +10 à skill nas chances.
    const temOuro = bag.some(i => i.defId === ouro);
    const temComum = bag.some(i => i.defId === comum);
    const bonus = temOuro ? 10 : 0;
    const base = recurso === 'minerio' ? mockMinerador : mockLenhador;
    const skill = base + bonus;
    const soma = tabela.filter(m => skill >= m[2]).reduce((n, m) => n + m[5], 0);
    const chances = tabela.map(([material, tora, min, de, ate, peso]) => {
      const trancada = skill < min;
      const acerto = Math.min(1, Math.max(0, (skill - de) / (ate - de)));
      return { material, tora, skillMin: min, chance: trancada ? 0 : peso / soma * acerto, trancada };
    });
    return {
      id: recurso,
      mapa: recurso === 'minerio' ? 'mina-minoc' : 'floresta-yew',
      nome: recurso === 'minerio' ? 'Mina de Minoc' : 'Floresta de Yew',
      lotacao: 50, vagas: recurso === 'minerio' ? 31 : 37, arvores: 50,
      chances, falha: Math.max(0, 1 - chances.reduce((n, c) => n + c.chance, 0)),
      skill: base, ferramenta: temOuro ? ouro : temComum ? comum : null, bonus
    };
  }

  function estadoColeta(): ColetaEstado {
    const lugares = [lugarColeta('madeira'), lugarColeta('minerio')];
    const atual = lugares.find(l => l.id === (mockColeta?.recurso ?? 'madeira'))!;
    return {
      lugares,
      ordem: ordemColeta(),
      resumo: null,
      machadinha: atual.ferramenta,
      bonus: atual.bonus,
      cofreUsadas: vault.length,
      cofreVagas: 50,
      skill: atual.skill,
      vip: false,
      regras: { tentativaSeg: 4, golpes: 4, porAcerto: 2, vipColeta: 0.2, vipGanho: 0.2 }
    };
  }

  /** Um saque de cemitério de exemplo, para o mock ter o que vender. */
  function semearVendaDemo() {
    const linhas: [string, number, number | null][] = [
      ['bone', 46, null], ['bone-helm', 1, 30], ['bone-legs', 1, 30], ['bone-gloves', 1, 30],
      ['katana@valorite', 1, 52], ['heater', 1, 60], ['bandage', 38, null], ['greater-healing', 4, null], ['oak-log', 6, null]
    ];
    for (const [defId, qty, dur] of linhas) {
      const def = MOCK_ITEM_DEFS.get(defId);
      if (!def) continue;
      bag.push({ id: `i${nextItem++}`, defId, name: def.name, qty, dur, durMax: dur, weight: qty * def.weight, equippedSlot: null });
    }
  }

  function weightOf(rows: MutablePack[]) {
    return rows.reduce((s, i) => s + i.weight, 0);
  }

  function snapshot(): Pack {
    const items = bag.map(i => ({ ...i }));
    const gold = bag.filter(i => i.defId === 'gold' && !i.equippedSlot).reduce((s, i) => s + i.qty, 0);
    const silver = bag.filter(i => i.defId === 'silver' && !i.equippedSlot).reduce((s, i) => s + i.qty, 0);
    return { items, weight: weightOf(items), weightMax, gold, silver, prataBanco: bankSilver, ouroBanco: bankGold, cloth: clothMock() };
  }

  /** O visual que o servidor mandaria: o equipamento à mostra e o traje por cima. */
  function clothMock(): string {
    return clothDoTraje(trajeMock, { slots: MOCK_TRAJE_SLOTS, pecas: MOCK_TRAJE_PECAS, cores: MOCK_TRAJE_CORES, exclusivas: exclusivasMock() }, trajeFem, bag);
  }

  function snapshotBanco(): Banco {
    return {
      prata: bankSilver,
      ouro: bankGold,
      vagas: vault.length,
      vagasMax: 50,
      peso: pesoDoVault(),
      pesoMax: 800,
      itens: vault.map(v => ({ ...v }))
    };
  }

  function pesoDoVault(): number {
    return vault.reduce((s, v) => s + v.qty * (MOCK_ITEM_DEFS.get(v.defId)?.weight ?? 0), 0);
  }

  function receberNoPack(defId: string, qty: number, dur: number | null, nome: string) {
    const def = MOCK_ITEM_DEFS.get(defId);
    const w = def?.weight ?? 0.1;
    if (weightOf(bag) + qty * w > weightMax)
      throw new ApiError('A mochila não aguenta esse peso.', 409, 'banco.semPeso');
    if (def?.stackable) {
      empilharMock(bag, defId, qty, w, q => ({
        id: `i${nextItem++}`, defId, name: nome, qty: q, dur, durMax: null, weight: q * w, equippedSlot: null, material: def?.material ?? null
      }));
      return;
    }
    bag.push({
      id: `i${nextItem++}`,
      defId,
      name: nome,
      qty,
      dur,
      durMax: def && !def.stackable ? 60 : null,
      weight: qty * w,
      equippedSlot: null,
      material: def?.material ?? null
    });
  }

  function mockBoard(): HuntBoard {
    const pack = snapshot();
    const who = chars.find(c => c.shardId === activeShard);
    // O `resumo` da lista sai da estimativa na postura firme — é o que o
    // `ListAsync` faz no servidor, e é o que deixa o rail comparar caçadas.
    const hunts = MOCK_HUNTS.map(base => {
      const filtro = mockOrdem?.huntId === base.id ? mockFiltro : [...base.filtro];
      const firme = mockEstimate('firme', filtro);
      return {
        ...base,
        filtro,
        skillAtual: 50,
        resumo: { prataPorHora: firme.prataPorHora }
      };
    });
    return {
      cacadas: hunts,
      voce: {
        prata: pack.silver,
        peso: pack.weight,
        pesoMax: pack.weightMax,
        bandagem: pack.items.filter(i => i.defId === 'bandage' && !i.equippedSlot).reduce((s, i) => s + i.qty, 0)
      },
      ordem: mockOrdem ? { ...mockOrdem, ...contagemMock(mockOrdem), ...continuaMock(mockOrdem) } : null,
      morto: !!who?.dead,
      precoBandagem: 5,
      vip: mockVip,
      regras: { recallS: 4.5, guardarS: 3, vendaS: 2, recompraMin: 15, raroPadrao: 10, raroMin: 0, raroMax: 50, banco: 'Minoc' },
      fora: mockForaAberto
        ? {
            segundos: 3 * 3600, mortos: 1240, prata: 46_310, viagens: 3, guardados: 722, vendas: 0, prataDaVenda: 0,
            vendidos: 0, vipVenceu: false, fim: null, cidade: 'Minoc', huntId: 'cemiterio-britain'
          }
        : null
    };
  }

  /** As viagens, a venda e a pausa no mock: um ciclo de 40 s, para a janela ter o que mostrar. */
  function continuaMock(o: HuntOrder): Pick<HuntOrder, 'pausa' | 'cofre' | 'venda'> {
    const min = Math.max(0, (Date.now() - Date.parse(o.startedAt)) / 60000);
    const viagens = Math.floor(min / 8);
    const vende = o.aoEncher === 'vender';
    const tipo = mockParam('mockpausa');
    let pausa: HuntOrder['pausa'] = null;
    if (tipo === 'cofre' || tipo === 'venda') {
      const ciclo = 40_000;
      const inicio = Math.floor(Date.now() / ciclo) * ciclo;
      pausa = tipo === 'cofre'
        ? { tipo, fases: [{ codigo: 'recall-ida', ateMs: inicio + 4500 }, { codigo: 'guardando', ateMs: inicio + 7500 }, { codigo: 'recall-volta', ateMs: inicio + 12_000 }] }
        : { tipo, fases: [{ codigo: 'vendendo', ateMs: inicio + 2000 }] };
      if (Date.now() >= pausa.fases[pausa.fases.length - 1].ateMs) pausa = null;
    }
    return {
      pausa,
      cofre: {
        itens: vende ? 0 : viagens * 113, prata: viagens * 4100, viagens: vende ? 0 : viagens,
        saque: vende ? {} : ({ bone: viagens * 96, 'bone-chest': viagens * 4 } as Record<string, number>)
      },
      venda: {
        prata: vende ? viagens * 224 : 0, itens: vende ? viagens * 224 : 0, vendas: vende ? viagens : 0,
        saque: vende ? ({ bone: viagens * 224 } as Record<string, number>) : {}
      }
    };
  }

  /** A contagem da caçada no mock: abates, prata e saque que crescem com o tempo, como numa caçada de verdade. */
  function contagemMock(o: HuntOrder) {
    const hunt = MOCK_HUNTS.find(h => h.id === o.huntId);
    const min = Math.max(0, (Date.now() - Date.parse(o.startedAt)) / 60000);
    const abates: Record<string, number> = {};
    let prata = 0;
    const saque: Record<string, number> = {};
    for (const m of hunt?.inimigos ?? []) {
      const n = Math.floor(min * 1.6 * (m.quantidade / 20) + (m.quantidade > 10 ? 3 : 1));
      abates[m.defId] = n;
      for (const l of hunt?.loot ?? []) {
        const p = l.porMob?.find(x => x.mobId === m.defId);
        if (!p || !o.filtro.includes(l.defId)) continue;
        const q = Math.round(n * (p.chance / 100) * ((p.qtdMin + p.qtdMax) / 2));
        if (l.defId === 'silver') prata += q;
        else if (q > 0) saque[l.defId] = (saque[l.defId] ?? 0) + q;
      }
    }
    return { abates, prata, saque };
  }

  function mockEstimate(postura: HuntPostura, filtro: readonly string[]): HuntEstimate {
    const fora = postura === 'cautelosa' ? 14.6 : postura === 'temeraria' ? 2 : 8.2;
    const recuar = postura === 'cautelosa' ? 60 : postura === 'firme' ? 35 : 0;
    const maxInimigos = postura === 'cautelosa' ? 1 : postura === 'firme' ? 2 : 0;
    const tempoDeLuta = 13.4;
    const mortesPorHora = 3600 / (tempoDeLuta + fora);
    const pegaPrata = filtro.includes('silver');
    const prataPorHora = pegaPrata ? Math.round(37.5 * mortesPorHora) : 0;
    let pesoPorHora = pegaPrata ? prataPorHora * 0.02 : 0;
    if (filtro.includes('bone')) pesoPorHora += 2 * 0.1 * mortesPorHora;
    const pack = snapshot();
    const vigor = 5 * 3600 + 19 * 60;
    const folga = pack.weightMax - pack.weight;
    const mochila = pesoPorHora <= 1e-9 ? 536870911 : Math.max(0, Math.floor(folga / (pesoPorHora / 3600)));
    const skillsEmJogo = [
      { id: 'swordsmanship', motivo: 'arma-de-corte', pontosNaViagem: 6.3 },
      { id: 'tactics', motivo: 'arma-equipada', pontosNaViagem: 6.2 }
    ];
    return {
      segundosAteVigor: vigor,
      segundosAteMochila: mochila,
      prataPorHora,
      pesoPorHora: Math.round(pesoPorHora * 10000) / 10000,
      mortesPorHora,
      pontosDaViagem: 12.5,
      skillsEmJogo,
      recuarAbaixoDe: recuar,
      maxInimigos,
      curarAteCheio: postura === 'cautelosa',
      segundosForaDeLuta: fora,
      tempoDeLuta
    };
  }

  function mockGmSkills(name: string): GmSkills {
    const born = MOCK_CATALOG.professions[0];
    const picks = new Map((born.skills ?? []).map(s => [s.id, s.value]));
    const skills = MOCK_CATALOG.skills.map(s => ({
      id: s.id,
      name: s.label,
      group: s.group,
      value: mockGmSkillValues?.get(s.id) ?? picks.get(s.id) ?? 0,
      lock: skillLocks.get(s.id) ?? 'raise' as SkillLock
    }));
    return {
      characterId: chars[0]?.id ?? 'c1',
      name,
      skills,
      total: skills.reduce((n, s) => n + s.value, 0),
      skillCap: 500,
      atributos: { ...mockGmAtributos, statCap: 300, teto: 100 }
    };
  }

  function sheet(): Profile {
    const born = MOCK_CATALOG.professions[0];
    const picks = new Map((born.skills ?? []).map(s => [s.id, s.value]));
    const skills = MOCK_CATALOG.skills.map(s => ({
      id: s.id,
      name: s.label,
      group: s.group,
      value: picks.get(s.id) ?? 0,
      lock: skillLocks.get(s.id) ?? 'raise' as SkillLock,
      ganho: marcoMock ? Math.round(((picks.get(s.id) ?? 0) - (marcoMock.get(s.id) ?? 0)) * 10) / 10 : (picks.get(s.id) ? 0.2 : 0)
    }));
    const who = chars.find(c => c.shardId === activeShard);
    const worn = bag.filter(i => i.equippedSlot);
    const main = worn.find(i => i.equippedSlot === 'mainHand');
    const dmg = mockWeaponDamage(main?.defId, strength, picks.get('tactics') ?? 0, picks.get('anatomy') ?? 0);
    return {
      name: who?.name ?? session?.displayName ?? 'Kelso',
      profession: 'Guerreiro',
      templates: picks.get('swordsmanship')! >= 50 ? ['Guerreiro'] : [],
      notoriety: who?.notoriety ?? 'inocente',
      homeCity: who?.homeCity ?? 'Britain',
      stats: {
        strength,
        dexterity: 25,
        intelligence: 10,
        strengthBase: strength,
        dexterityBase: 25,
        intelligenceBase: 10,
        sum: strength + 25 + 10,
        cap: 300
      },
      vitals: { hits: 100, hitsMax: 100, mana: 10, manaMax: 10, stam: 25, stamMax: 25, fadiga: 1440, fadigaMax: 1440 },
      carry: { weight: weightOf(bag), weightMax },
      skills,
      skillTotal: skills.reduce((s, x) => s + x.value, 0),
      skillCap: 500,
      combat: {
        ar: mockArmor(worn),
        damageMin: dmg?.min ?? null,
        damageMax: dmg?.max ?? null,
        velAtaqueBp: 500,
        velMagiaBp: 500,
        swingSegundos: 1,
        cicloMagiaSegundos: 2.5,
        swingSegundosBase: 1,
        cicloMagiaSegundosBase: 2.5,
        conjunto: { familia: 'nenhuma', pecas: 0, pecasExigidas: 5, completo: true },
        itens: [],
        velMovimento: worn.some(i => i.equippedSlot === 'mount') ? 1.15 : 1
      },
      guildTag: house?.tag ?? '',
      guildName: house?.name ?? ''
    };
  }
}

function mockHouse(name: string, tag: string, leader: string, rank: GuildRankWire): Guild {
  return {
    id: `g-${tag}`,
    name,
    tag,
    motd: '',
    gold: 0,
    rank,
    title: '',
    tithe: 0,
    canInvite: rank === 'lider' || rank === 'emissario',
    canKickRecruit: rank !== 'recruta',
    canKickMember: rank === 'lider' || rank === 'emissario',
    canKickAny: rank === 'lider',
    canRank: rank === 'lider' || rank === 'emissario',
    canLead: rank === 'lider',
    canMotd: rank === 'lider' || rank === 'emissario',
    canVault: rank === 'lider',
    canAlliance: rank === 'lider',
    canWar: rank === 'lider' || rank === 'comandante',
    canVote: rank !== 'recruta',
    members: [{ name: leader, rank, title: '', tithe: 0, joinedAt: new Date().toISOString(), online: true }],
    alliance: null,
    wars: [],
    votes: [],
    online: 1
  };
}

const SHIELD_AR: Record<string, number> = {
  heater: 23
};

const DICE: Record<string, string> = {
  katana: '3d8+2',
  dagger: '3d5',
  'large-battle-axe': '2d17+4',
  'gnarled-staff': '5d5+5',
  bow: '4d9+5',
  'heavy-crossbow': '5d10+6'
};

function mockWeaponDamage(defId: string | undefined, str: number, tactics: number, anatomy: number) {
  if (!defId) return null;
  const raw = DICE[defId];
  if (!raw) return null;
  const m = raw.match(/^(\d+)d(\d+)([+-]\d+)?$/i);
  if (!m) return null;
  const n = Number(m[1]);
  const s = Number(m[2]);
  const b = m[3] ? Number(m[3]) : 0;
  const min = n + b;
  const max = n * s + b;
  const factor = 1 + str / 100 * 0.3 + tactics / 100 * 0.6 + anatomy / 100 * 0.3;
  return {
    min: Math.round(min * factor),
    max: Math.round(max * factor)
  };
}

function mockArmor(worn: MutablePack[]) {
  let sum = 0;
  for (const item of worn) {
    const def = MOCK_ITEM_DEFS.get(item.defId);
    if (!def || def.equipSlot === 'weapon') continue;
    if (def.equipSlot === 'shield') {
      sum += SHIELD_AR[item.defId] ?? 0;
      continue;
    }
    sum += fallbackAr(item.defId);
  }
  return sum;
}

function fallbackAr(id: string) {
  const dash = id.indexOf('-');
  const mat = dash < 0 ? id : id.slice(0, dash);
  const piece = dash < 0 ? '' : id.slice(dash + 1);
  const body = mat === 'leather' ? 1
    : mat === 'studded' || mat === 'bone' ? 2
    : mat === 'plate' ? 4
    : 1;
  if (piece === 'chest') return body + 2;
  if (piece === 'legs') return body + 1;
  if (piece === 'helm') return body;
  return Math.max(1, body - 1);
}

type MutablePack = {
  id: string;
  defId: string;
  name: string;
  qty: number;
  dur: number | null;
  durMax: number | null;
  weight: number;
  equippedSlot: string | null;
  material?: string | null;
  abencoado?: boolean;
  qualidade?: number;
  feitoPor?: string | null;
};

type MutableBank = {
  id: string;
  defId: string;
  nome: string;
  qty: number;
  dur: number | null;
  durMax: number | null;
  material?: string | null;
};

const MOCK_FERRARIA = 50;
const MOCK_ALFAIATARIA = 50;
const MOCK_ARCOS = 50;

const SMITH_METALS: readonly { id: string; ingotDefId: string; skill: number }[] = [
  { id: 'iron', ingotDefId: 'iron-ingot', skill: 0 },
  { id: 'dull-copper', ingotDefId: 'dull-copper-ingot', skill: 65 },
  { id: 'shadow-iron', ingotDefId: 'shadow-iron-ingot', skill: 70 },
  { id: 'copper', ingotDefId: 'copper-ingot', skill: 75 },
  { id: 'bronze', ingotDefId: 'bronze-ingot', skill: 80 },
  { id: 'golden', ingotDefId: 'golden-ingot', skill: 85 },
  { id: 'agapite', ingotDefId: 'agapite-ingot', skill: 90 },
  { id: 'verite', ingotDefId: 'verite-ingot', skill: 95 },
  { id: 'valorite', ingotDefId: 'valorite-ingot', skill: 99 }
];

function tMock(code: string): string {
  return code;
}

/** A oficina no modo mock: os padrões do servidor (CraftReceitas.cs e CraftRegras.cs). */
const MOCK_NOME = 'Aldric';
const OFICINA_REGRAS = { bonus: 15, excepcional: 25, chanceBase: 2, chancePorPonto: 0.8, chanceTeto: 35, chanceMestre: 5 };
const OFICINA_RECEITAS: readonly { defId: string; oficio: Oficio; qtd: number; pericia: number; dado?: string; ar?: number }[] = [
  { defId: 'dagger', oficio: 'ferraria', qtd: 3, pericia: 0, dado: '3d5' },
  { defId: 'large-battle-axe', oficio: 'ferraria', qtd: 12, pericia: 28, dado: '2d17+4' },
  { defId: 'katana', oficio: 'ferraria', qtd: 8, pericia: 44.1, dado: '3d8+2' },
  { defId: 'heater', oficio: 'ferraria', qtd: 18, pericia: 40.5, ar: 23 },
  { defId: 'plate-helm', oficio: 'ferraria', qtd: 15, pericia: 58.6, ar: 4 },
  { defId: 'plate-chest', oficio: 'ferraria', qtd: 25, pericia: 75, ar: 6 },
  { defId: 'plate-arms', oficio: 'ferraria', qtd: 18, pericia: 63.5, ar: 3 },
  { defId: 'plate-gloves', oficio: 'ferraria', qtd: 12, pericia: 53.7, ar: 3 },
  { defId: 'plate-legs', oficio: 'ferraria', qtd: 20, pericia: 66.8, ar: 5 },
  { defId: 'bow', oficio: 'arcos', qtd: 7, pericia: 30, dado: '4d9+5' },
  { defId: 'gnarled-staff', oficio: 'arcos', qtd: 7, pericia: 78.9, dado: '5d5+5' },
  { defId: 'heavy-crossbow', oficio: 'arcos', qtd: 10, pericia: 80, dado: '5d10+6' },
  { defId: 'studded-helm', oficio: 'alfaiataria', qtd: 6, pericia: 25, ar: 1 },
  { defId: 'studded-gloves', oficio: 'alfaiataria', qtd: 8, pericia: 32.9, ar: 1 },
  { defId: 'studded-arms', oficio: 'alfaiataria', qtd: 10, pericia: 43, ar: 1 },
  { defId: 'studded-legs', oficio: 'alfaiataria', qtd: 12, pericia: 54, ar: 4 },
  { defId: 'studded-chest', oficio: 'alfaiataria', qtd: 14, pericia: 54, ar: 5 }
];
/** A família, a perícia e a ferramenta portátil de cada oficina (CraftReceitas.FamiliaDo / PericiaDo). */
const OFICINA_DO = {
  ferraria: { familia: 'metal', pericia: () => MOCK_FERRARIA, ferramenta: null, pre: 'ferraria' },
  arcos: { familia: 'madeira', pericia: () => MOCK_ARCOS, ferramenta: 'fletcher-tools', pre: 'arcos' },
  alfaiataria: { familia: 'couro', pericia: () => MOCK_ALFAIATARIA, ferramenta: 'sewing-kit', pre: 'alfaiataria' }
} as const;
const PERICIA_COURO: Record<string, number> = { leather: 0, 'spined-leather': 65, 'horned-leather': 80, 'barbed-leather': 95 };
const PERICIA_MADEIRA: Record<string, number> = { wood: 0, oak: 65, ash: 75, yew: 85, heartwood: 95, bloodwood: 95, frostwood: 95 };
const FORCA_MOCK: Record<string, number> = {
  'dull-copper': 5, 'shadow-iron': 10, copper: 15, bronze: 20, golden: 26, agapite: 33, verite: 41, valorite: 50,
  oak: 6, ash: 13, yew: 21, heartwood: 30, bloodwood: 40, frostwood: 50
};
const OFICINA_MATERIAIS = MATERIAIS.map(m => ({
  ...m,
  pericia: m.familia === 'metal' ? (SMITH_METALS.find(x => x.id === m.id)?.skill ?? 0)
    : m.familia === 'couro' ? (PERICIA_COURO[m.id] ?? 0) : (PERICIA_MADEIRA[m.id] ?? 0),
  forca: FORCA_MOCK[m.id] ?? 0
}));

function chanceMock(pericia: number, exigida: number): number {
  const r = OFICINA_REGRAS;
  if (pericia < exigida) return 0;
  let c = Math.min(r.chanceTeto, r.chanceBase + r.chancePorPonto * (pericia - exigida));
  if (pericia >= 100) c += r.chanceMestre;
  return c;
}

function mockOficinaMenu(oficio: Oficio, bag: MutablePack[]): OficinaMenu {
  const of = OFICINA_DO[oficio];
  const pericia = of.pericia();
  const mats = OFICINA_MATERIAIS.filter(m => m.familia === of.familia);
  return {
    oficio,
    pericia,
    temFerramenta: !of.ferramenta || bag.some(i => i.defId === of.ferramenta && !i.equippedSlot),
    feitoPor: MOCK_NOME,
    materiais: mats.map(m => ({
      id: m.id, nome: m.nome, cor: m.cor, padrao: m.padrao, insumo: m.insumo,
      insumoNome: MOCK_ITEM_DEFS.get(m.insumo)?.name ?? m.insumo, qty: somaSolta(bag, m.insumo),
      pericia: m.pericia, pode: pericia >= m.pericia, forca: m.forca
    })),
    receitas: OFICINA_RECEITAS.filter(r => r.oficio === oficio).map(r => {
      const def = MOCK_ITEM_DEFS.get(r.defId);
      return {
        defId: r.defId, nome: def?.name ?? r.defId, grupo: r.ar !== undefined ? (r.defId === 'heater' ? 'shield' : 'armor') : 'weapon',
        slot: def?.equipSlot ?? '', qtd: r.qtd, pericia: r.pericia,
        bonus: OFICINA_REGRAS.bonus, excepcional: OFICINA_REGRAS.excepcional, ativa: true,
        fichas: mats.map(m => {
          const id = idDaVariante(r.defId, m.id);
          return { material: m.id, defId: id, nome: MOCK_ITEM_DEFS.get(id)?.name ?? id, dado: r.dado ?? null, ar: r.ar ?? null };
        })
      };
    }),
    regras: OFICINA_REGRAS
  };
}


/** Teto de pilha (Renato, 16/10): 999 por linha, como o `Pilhas.Max` do servidor. Prata e ouro sem teto. */
export const PILHA_MAX = 999;
const tetoDe = (defId: string) => (defId === 'silver' || defId === 'gold' ? Number.MAX_SAFE_INTEGER : PILHA_MAX);

/** Soma das pilhas soltas do def. */
function somaSolta(bag: readonly MutablePack[], defId: string): number {
  return bag.filter(i => i.defId === defId && !i.equippedSlot).reduce((a, i) => a + i.qty, 0);
}

/** Completa as pilhas soltas (a mais cheia primeiro) e abre linhas de até 999 com o resto. Devolve a última tocada. */
/** As compras da cidade no mock: as lojas de Minoc (world_npcs publicado, 29/10/2026). */
const MOCK_CIDADE_LOJA: CidadeItem[] = ([
  ['mago-minoc', 'Merlin', 'npc.titulo.mago', 'gnarled-staff', 'Bastão retorcido', 300, 3, 'weapon', 'weapon', 0, '1d5+16', 2, 10, 1, false],
  ['mago-minoc', 'Merlin', 'npc.titulo.mago', 'cure-poison', 'Poção de cura veneno', 10, 0.1, 'potion', 'none', 0, null, 0, 0, null, true],
  ['mago-minoc', 'Merlin', 'npc.titulo.mago', 'greater-healing', 'Poção de vida maior', 15, 0.1, 'potion', 'none', 0, null, 0, 0, null, true],
  ['ferreiro-minoc', 'Hrothgar', 'npc.titulo.ferreiro', 'katana', 'Katana', 300, 6, 'weapon', 'weapon', 0, '1d8+11', 1, 10, 1, false],
  ['ferreiro-minoc', 'Hrothgar', 'npc.titulo.ferreiro', 'dagger', 'Adaga', 300, 1, 'weapon', 'weapon', 0, '1d5+8', 1, 1, 1, false],
  ['ferreiro-minoc', 'Hrothgar', 'npc.titulo.ferreiro', 'large-battle-axe', 'Machado de batalha grande', 300, 11, 'weapon', 'weapon', 0, '1d10+19', 2, 0, 1, false],
  ['ferreiro-minoc', 'Hrothgar', 'npc.titulo.ferreiro', 'hatchet', 'Machadinha', 50, 4, 'weapon', 'weapon', 0, null, 2, 15, null, false],
  ['ferreiro-minoc', 'Hrothgar', 'npc.titulo.ferreiro', 'pickaxe', 'Picareta', 50, 4, 'misc', 'weapon', 0, null, 2, 0, null, false],
  ['armeiro-minoc', 'Sigrun', 'npc.titulo.armeiro', 'plate-helm', 'Elmo de placas', 150, 2, 'armor', 'helm', 4, null, 0, 0, null, false],
  ['armeiro-minoc', 'Sigrun', 'npc.titulo.armeiro', 'plate-chest', 'Peitoral de placas', 200, 5, 'armor', 'chest', 6, null, 0, 0, null, false],
  ['armeiro-minoc', 'Sigrun', 'npc.titulo.armeiro', 'plate-legs', 'Perneiras de placas', 150, 3, 'armor', 'legs', 5, null, 0, 0, null, false],
  ['armeiro-minoc', 'Sigrun', 'npc.titulo.armeiro', 'heater', 'Escudo heater', 100, 8, 'shield', 'shield', 23, null, 0, 0, null, false],
  ['provisor-minoc', 'Bera', 'npc.titulo.provisor', 'bandage', 'Bandagem', 5, 0.1, 'misc', 'none', 0, null, 0, 0, null, true],
  ['arqueiro-minoc', 'Ulric', 'npc.titulo.arqueiro', 'arrow', 'Flecha', 1, 0.01, 'ammo', 'none', 0, null, 0, 0, null, true],
  ['arqueiro-minoc', 'Ulric', 'npc.titulo.arqueiro', 'bow', 'Arco', 300, 6, 'weapon', 'weapon', 0, '1d9+14', 2, 20, 10, false],
  ['estabuleiro-minoc', 'Ingrid', 'npc.titulo.estabuleiro', 'cavalo-baio', 'Cavalo Baio', 50000, 0, 'mount', 'mount', 0, null, 0, 0, null, false],
  ['alfaiate-minoc', 'Elora', 'npc.titulo.alfaiate', 'sewing-kit', 'Kit de costura', 120, 2, 'misc', 'none', 0, null, 0, 0, null, false],
  ['alfaiate-minoc', 'Elora', 'npc.titulo.alfaiate', 'bandage', 'Bandagem', 5, 0.1, 'misc', 'none', 0, null, 0, 0, null, true],
  ['alfaiate-minoc', 'Elora', 'npc.titulo.alfaiate', 'studded-helm', 'Elmo de couro cravejado', 35, 1, 'armor', 'helm', 1, null, 0, 0, null, false],
  ['alfaiate-minoc', 'Elora', 'npc.titulo.alfaiate', 'studded-gloves', 'Luvas de couro cravejado', 40, 1, 'armor', 'gloves', 1, null, 0, 0, null, false],
  ['alfaiate-minoc', 'Elora', 'npc.titulo.alfaiate', 'studded-arms', 'Braçadeiras de couro cravejado', 60, 4, 'armor', 'arms', 1, null, 0, 0, null, false],
  ['alfaiate-minoc', 'Elora', 'npc.titulo.alfaiate', 'studded-legs', 'Perneiras de couro cravejado', 80, 5, 'armor', 'legs', 4, null, 0, 0, null, false],
  ['alfaiate-minoc', 'Elora', 'npc.titulo.alfaiate', 'studded-chest', 'Peitoral de couro cravejado', 100, 8, 'armor', 'chest', 5, null, 0, 0, null, false]
] as const).map(([npcId, npcNome, npcTitulo, defId, nome, preco, peso, grupo, slot, ar, dano, maos, forca, alcance, empilha]): CidadeItem =>
  ({ npcId, npcNome, npcTitulo, defId, nome, preco, peso, grupo, slot, ar, dano, maos, forca, alcance, empilha }))
  // O Odo (Marceneiro) e as ferramentas de ofício nos NPCs do ofício (techspec-marceneiro-e-oficios-em-casa §02).
  .concat(MOBILIA.filter(m => !m.oficio && m.raridade <= 1).map(m => ({
    npcId: 'marceneiro-minoc', npcNome: 'Odo', npcTitulo: 'npc.titulo.marceneiro', defId: m.id, nome: t(`item.${m.id}`), preco: m.preco,
    peso: 3, grupo: 'furniture', slot: 'none', ar: 0, dano: null, maos: 0, forca: 0, alcance: null, empilha: false,
    raridade: m.raridade, conjunto: m.conjunto, oficio: null, jaTem: false, luz: m.luz
  })))
  .concat(FERRAMENTAS_OFICIO.map(f => ({
    npcId: ({ ferraria: 'ferreiro-minoc', alfaiataria: 'alfaiate-minoc', arcos: 'arqueiro-minoc', treino: 'armeiro-minoc' } as Record<string, string>)[f.oficio],
    npcNome: ({ ferraria: 'Hrothgar', alfaiataria: 'Elora', arcos: 'Ulric', treino: 'Sigrun' } as Record<string, string>)[f.oficio],
    npcTitulo: f.titulo, defId: f.defId, nome: t(`item.${f.defId}`), preco: REGRAS_MOCK(f.oficio).preco, peso: 10, grupo: 'furniture', slot: 'none',
    ar: 0, dano: null, maos: 0, forca: 0, alcance: null, empilha: false, raridade: 4, conjunto: 'oficios', oficio: f.oficio, jaTem: false, luz: false
  })));

/** Os números padrão das ferramentas de ofício (OficioCasaRegras.cs). */
function REGRAS_MOCK(oficio: string): FerramentaRegras {
  const defId = FERRAMENTAS_OFICIO.find(f => f.oficio === oficio)?.defId ?? '';
  if (oficio === 'treino') return { oficio, defId, ativa: true, preco: 525000, ganho: 25, tempo: 0, excepcional: 0, economia: 0, atributo: 15 };
  return { oficio, defId, ativa: true, preco: oficio === 'ferraria' ? 675000 : 600000, ganho: 20, tempo: 10, excepcional: 5, economia: 10, atributo: 0 };
}

/** As vagas de ofício padrão por modelo (CasaModelos.OficiosPadrao). */
function VAGAS_OFICIO_MOCK(modelo: string): number {
  if (['marmore', 'torre', 'fortaleza'].includes(modelo)) return 4;
  if (['villa', 'tijolo-grande', 'patio-grande', 'dois-andares-madeira', 'dois-andares-pedra'].includes(modelo)) return 3;
  if (['loja-pedra', 'loja-marmore', 'torre-pequena', 'cabana', 'patio-arenito'].includes(modelo)) return 2;
  return 1;
}

function empilharMock(bag: MutablePack[], defId: string, qty: number, peso: number, nova: (q: number) => MutablePack): MutablePack {
  const teto = tetoDe(defId);
  let ultima: MutablePack | undefined;
  const abertas = bag.filter(i => i.defId === defId && !i.equippedSlot && i.qty < teto).sort((a, b) => b.qty - a.qty);
  for (const p of abertas) {
    if (qty <= 0) break;
    const cabe = Math.min(teto - p.qty, qty);
    p.qty += cabe;
    p.weight = p.qty * peso;
    qty -= cabe;
    ultima = p;
  }
  while (qty > 0) {
    const q = Math.min(teto, qty);
    const r = nova(q);
    bag.push(r);
    qty -= q;
    ultima = r;
  }
  return ultima!;
}

/** Gasta das pilhas soltas, da menor para a maior. */
function gastarMock(bag: MutablePack[], defId: string, qtd: number, peso: number) {
  const pilhas = bag.filter(i => i.defId === defId && !i.equippedSlot).sort((a, b) => a.qty - b.qty);
  for (const pilha of pilhas) {
    if (qtd <= 0) return;
    const tira = Math.min(pilha.qty, qtd);
    qtd -= tira;
    if (tira === pilha.qty) bag.splice(bag.indexOf(pilha), 1);
    else {
      pilha.qty -= tira;
      pilha.weight = pilha.qty * peso;
    }
  }
}


const TAILOR_RECIPES: readonly { defId: string; material: string; qtd: number; skill: number; rende: number }[] = [
  { defId: 'bandage',         material: 'cloth',   qtd: 5,  skill: 0,    rende: 5 }
];

function mockTailorMenu(bag: MutablePack[]): TailorMenu {
  const livre = (defId: string) => somaSolta(bag, defId);
  return {
    alfaiataria: MOCK_ALFAIATARIA,
    temKit: bag.some(i => i.defId === 'sewing-kit' && !i.equippedSlot),
    pano: livre('cloth'),
    receitas: TAILOR_RECIPES.map(r => {
      const def = MOCK_ITEM_DEFS.get(r.defId);
      const mat = MOCK_ITEM_DEFS.get(r.material);
      return {
        defId: r.defId,
        name: def?.name ?? r.defId,
        material: r.material,
        materialName: mat?.name ?? r.material,
        qtd: r.qtd,
        rende: r.rende,
        tenho: livre(r.material),
        skill: Math.max(0, r.skill),
        podeSkill: MOCK_ALFAIATARIA >= r.skill
      };
    })
  };
}

const FLETCH_RECIPES: readonly { defId: string; insumos: readonly { defId: string; qtd: number }[]; skill: number; rende: number }[] = [
  { defId: 'shaft',          insumos: [{ defId: 'log', qtd: 10 }], skill: 0, rende: 10 },
  { defId: 'arrow',          insumos: [{ defId: 'shaft', qtd: 10 }, { defId: 'feather', qtd: 10 }], skill: 0, rende: 10 },
  { defId: 'bolt',           insumos: [{ defId: 'shaft', qtd: 10 }, { defId: 'feather', qtd: 10 }], skill: 0, rende: 10 }
];

function mockFletchMenu(bag: MutablePack[]): FletchMenu {
  const livre = (defId: string) => somaSolta(bag, defId);
  return {
    arcos: MOCK_ARCOS,
    temFerramenta: bag.some(i => i.defId === 'fletcher-tools' && !i.equippedSlot),
    tora: livre('log'),
    haste: livre('shaft'),
    pena: livre('feather'),
    receitas: FLETCH_RECIPES.map(r => {
      const def = MOCK_ITEM_DEFS.get(r.defId);
      return {
        defId: r.defId,
        name: def?.name ?? r.defId,
        insumos: r.insumos.map(ins => {
          const mat = MOCK_ITEM_DEFS.get(ins.defId);
          return { defId: ins.defId, name: mat?.name ?? ins.defId, qtd: ins.qtd, tenho: livre(ins.defId) };
        }),
        rende: r.rende,
        skill: Math.max(0, r.skill),
        podeSkill: MOCK_ARCOS >= r.skill
      };
    })
  };
}

const MOCK_HUNT: HuntView = {
  id: 'cemiterio-britain',
  aba: 'cacada',
  mapa: 'cemiterio-britain',
  nivel: 1,
  risco: 'baixo',
  skillSugerida: 'swordsmanship',
  skillSugeridaValor: 50,
  skillAtual: 50,
  inimigos: [{
    defId: 'skeleton',
    quantidade: 20,
    ninhos: 8,
    respawnMin: 45,
    respawnMax: 90,
    resumo: {
      defId: 'skeleton',
      nome: 'Esqueleto',
      hits: 46,
      ar: 20,
      magicResist: 25,
      poisonImmune: true,
      permiteParalisia: true,
      danoMin: 2,
      danoMax: 14,
      aparencia: 'skeleton'
    }
  }],
  loot: [
    { defId: 'silver', qtdMin: 25, qtdMax: 50, chance: 100, porMob: [{ mobId: 'skeleton', qtdMin: 25, qtdMax: 50, chance: 100 }] },
    { defId: 'bone', qtdMin: 1, qtdMax: 3, chance: 100, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 3, chance: 100 }] },
    { defId: 'bone-helm', qtdMin: 1, qtdMax: 1, chance: 3, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 1, chance: 3 }] },
    { defId: 'bone-chest', qtdMin: 1, qtdMax: 1, chance: 3, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 1, chance: 3 }] },
    { defId: 'bone-arms', qtdMin: 1, qtdMax: 1, chance: 3, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 1, chance: 3 }] },
    { defId: 'bone-gloves', qtdMin: 1, qtdMax: 1, chance: 3, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 1, chance: 3 }] },
    { defId: 'bone-legs', qtdMin: 1, qtdMax: 1, chance: 3, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 1, chance: 3 }] }
  ],
  skillsEmJogo: [
    { id: 'swordsmanship', motivo: 'arma-de-corte', pontosNaViagem: 6.3 },
    { id: 'tactics', motivo: 'arma-equipada', pontosNaViagem: 6.2 }
  ],
  filtro: ['silver', 'bone', 'bone-helm', 'bone-chest', 'bone-arms', 'bone-gloves', 'bone-legs'],
  recorde: null,
  temGuarda: false,
  protegida: { xp: 25, prata: 40, itens: 40, raros: 60, limiteRaro: 5 },
  // O board sobrescreve com a estimativa firme, como o servidor faz.
  resumo: { prataPorHora: 0 }
};

const MOCK_HUNT_COVE: HuntView = {
  id: 'cemiterio-cove',
  aba: 'cacada',
  mapa: 'cemiterio-cove',
  nivel: 2,
  risco: 'baixo',
  skillSugerida: 'swordsmanship',
  skillSugeridaValor: 70,
  skillAtual: 50,
  inimigos: [
    {
      defId: 'skeleton',
      quantidade: 5,
      ninhos: 2,
      respawnMin: 45,
      respawnMax: 75,
      resumo: {
        defId: 'skeleton',
        nome: 'Esqueleto',
        hits: 46,
        ar: 20,
        magicResist: 25,
        poisonImmune: true,
        permiteParalisia: true,
        danoMin: 2,
        danoMax: 14,
        aparencia: 'skeleton'
      }
    },
    {
      defId: 'spirit-ghost',
      quantidade: 15,
      ninhos: 6,
      respawnMin: 60,
      respawnMax: 110,
      resumo: {
        defId: 'spirit-ghost',
        nome: 'Espírito',
        hits: 58,
        ar: 12,
        magicResist: 45,
        poisonImmune: true,
        permiteParalisia: true,
        danoMin: 3,
        danoMax: 18,
        aparencia: 'spirit-ghost'
      }
    }
  ],
  loot: [
    { defId: 'silver', qtdMin: 25, qtdMax: 50, chance: 100, porMob: [{ mobId: 'skeleton', qtdMin: 25, qtdMax: 50, chance: 100 }, { mobId: 'spirit-ghost', qtdMin: 30, qtdMax: 60, chance: 100 }] },
    { defId: 'bone', qtdMin: 1, qtdMax: 3, chance: 100, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 3, chance: 100 }] },
    { defId: 'bone-helm', qtdMin: 1, qtdMax: 1, chance: 3, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 1, chance: 3 }] },
    { defId: 'bone-chest', qtdMin: 1, qtdMax: 1, chance: 3, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 1, chance: 3 }] },
    { defId: 'bone-arms', qtdMin: 1, qtdMax: 1, chance: 3, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 1, chance: 3 }] },
    { defId: 'bone-gloves', qtdMin: 1, qtdMax: 1, chance: 3, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 1, chance: 3 }] },
    { defId: 'bone-legs', qtdMin: 1, qtdMax: 1, chance: 3, porMob: [{ mobId: 'skeleton', qtdMin: 1, qtdMax: 1, chance: 3 }] }
  ],
  skillsEmJogo: [
    { id: 'swordsmanship', motivo: 'arma-de-corte', pontosNaViagem: 6.3 },
    { id: 'tactics', motivo: 'arma-equipada', pontosNaViagem: 6.2 }
  ],
  filtro: ['silver', 'bone', 'bone-helm', 'bone-chest', 'bone-arms', 'bone-gloves', 'bone-legs'],
  recorde: null,
  temGuarda: false,
  protegida: { xp: 25, prata: 40, itens: 40, raros: 60, limiteRaro: 5 },
  resumo: { prataPorHora: 0 }
};

/** Ice Dungeon (techspec-ice-dungeon): nove inimigos, sem drop. É a ficha que abre o carrossel. */
const MOCK_HUNT_ICE: HuntView = {
  id: 'ice-dungeon',
  aba: 'cacada',
  mapa: 'ice-dungeon',
  nivel: 4,
  risco: 'alto',
  skillSugerida: 'swordsmanship',
  skillSugeridaValor: 100,
  skillAtual: 50,
  inimigos: [
    {
      defId: 'arctic-ogre-lord', quantidade: 1, ninhos: 1, respawnMin: 60, respawnMax: 120,
      resumo: { defId: 'arctic-ogre-lord', nome: 'Senhor Ogro Ártico', hits: 550, ar: 55, magicResist: 75, poisonImmune: true, permiteParalisia: false, danoMin: 4, danoMax: 48, aparencia: 'arctic-ogre-lord' }
    },
    {
      defId: 'frost-ooze', quantidade: 7, ninhos: 2, respawnMin: 60, respawnMax: 120,
      resumo: { defId: 'frost-ooze', nome: 'Lodo Gélido', hits: 22, ar: 20, magicResist: 15, poisonImmune: false, permiteParalisia: true, danoMin: 2, danoMax: 8, aparencia: 'frost-ooze' }
    },
    {
      defId: 'frost-spider', quantidade: 7, ninhos: 2, respawnMin: 60, respawnMax: 120,
      resumo: { defId: 'frost-spider', nome: 'Aranha Gélida', hits: 60, ar: 20, magicResist: 30, poisonImmune: false, permiteParalisia: true, danoMin: 2, danoMax: 16, aparencia: 'frost-spider' }
    },
    {
      defId: 'frost-troll', quantidade: 5, ninhos: 2, respawnMin: 60, respawnMax: 120,
      resumo: { defId: 'frost-troll', nome: 'Troll Gélido', hits: 156, ar: 40, magicResist: 70, poisonImmune: false, permiteParalisia: true, danoMin: 3, danoMax: 24, aparencia: 'frost-troll' }
    },
    {
      defId: 'ice-elemental', quantidade: 5, ninhos: 2, respawnMin: 60, respawnMax: 120,
      resumo: { defId: 'ice-elemental', nome: 'Elemental de Gelo', hits: 111, ar: 40, magicResist: 70, poisonImmune: true, permiteParalisia: true, danoMin: 3, danoMax: 21, aparencia: 'ice-elemental' }
    },
    {
      defId: 'ice-fiend', quantidade: 1, ninhos: 1, respawnMin: 60, respawnMax: 120,
      resumo: { defId: 'ice-fiend', nome: 'Demônio de Gelo', hits: 400, ar: 50, magicResist: 85, poisonImmune: false, permiteParalisia: false, danoMin: 4, danoMax: 40, aparencia: 'ice-fiend' }
    },
    {
      defId: 'ice-serpent', quantidade: 2, ninhos: 1, respawnMin: 60, respawnMax: 120,
      resumo: { defId: 'ice-serpent', nome: 'Serpente de Gelo', hits: 147, ar: 30, magicResist: 30, poisonImmune: false, permiteParalisia: true, danoMin: 3, danoMax: 18, aparencia: 'ice-serpent' }
    },
    {
      defId: 'ice-snake', quantidade: 6, ninhos: 2, respawnMin: 60, respawnMax: 120,
      resumo: { defId: 'ice-snake', nome: 'Cobra de Gelo', hits: 35, ar: 18, magicResist: 20, poisonImmune: true, permiteParalisia: true, danoMin: 2, danoMax: 12, aparencia: 'ice-snake' }
    },
    {
      defId: 'snow-elemental', quantidade: 5, ninhos: 2, respawnMin: 60, respawnMax: 120,
      resumo: { defId: 'snow-elemental', nome: 'Elemental de Neve', hits: 213, ar: 45, magicResist: 60, poisonImmune: true, permiteParalisia: true, danoMin: 6, danoMax: 21, aparencia: 'snow-elemental' }
    }
  ],
  loot: [],
  skillsEmJogo: [
    { id: 'swordsmanship', motivo: 'arma-de-corte', pontosNaViagem: 6.3 },
    { id: 'tactics', motivo: 'arma-equipada', pontosNaViagem: 6.2 }
  ],
  filtro: [],
  recorde: null,
  temGuarda: false,
  protegida: { xp: 25, prata: 40, itens: 40, raros: 60, limiteRaro: 5 },
  resumo: { prataPorHora: 0 }
};

const MOCK_HUNTS: readonly HuntView[] = [MOCK_HUNT, MOCK_HUNT_COVE, MOCK_HUNT_ICE];

/** Nomes falsos determinísticos para o `?mockgm=1` (o mesmo índice dá sempre o mesmo jogador). */
function gerarFalsosGm(n: number): GmOnline[] {
  const silabas = ['ar', 'bel', 'cor', 'dra', 'el', 'fen', 'gar', 'hal', 'is', 'jor', 'kal', 'lu', 'mor', 'nar', 'os', 'pel', 'quin', 'ra', 'sil', 'tor', 'ul', 'var', 'wen', 'yr', 'zan'];
  const cidades = ['Britain', 'Britain', 'Minoc', 'Cemitério de Britain'];
  const notos = ['inocente', 'inocente', 'inocente', 'criminoso', 'assassino'] as const;
  const tags = ['', '', 'KoV', 'ORC', 'GoL', ''];
  const out: GmOnline[] = [];
  let x = 7;
  const r = () => (x = (x * 1103515245 + 12345) & 0x7fffffff) / 0x7fffffff;
  for (let i = 0; i < n; i++) {
    const partes = 2 + Math.floor(r() * 2);
    let nome = '';
    for (let k = 0; k < partes; k++) nome += silabas[Math.floor(r() * silabas.length)];
    nome = nome[0].toUpperCase() + nome.slice(1) + (r() < 0.3 ? String(i % 100) : '');
    const tag = tags[Math.floor(r() * tags.length)];
    out.push({
      id: `falso-${i}`,
      name: nome,
      city: cidades[Math.floor(r() * cidades.length)],
      dead: r() < 0.05,
      you: false,
      notoriety: notos[Math.floor(r() * notos.length)],
      guildTag: tag || undefined,
      guildName: tag ? `Guilda ${tag}` : undefined,
      canal: Math.floor(r() * 12),
      vipAteMs: r() < 0.1 ? Date.now() + 86_400_000 * 20 : undefined
    });
  }
  return out;
}
